import React, {
	PureComponent,
} from 'react';

import Icons from '@touchsource/tsicons';

import QRCode from 'qrcode.react';

import {
	FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';

import {
	faMobileAlt,
	faSpinner,
	faRefresh,
	faPlus,
	faMinus,
} from '@fortawesome/free-solid-svg-icons';

import {
	calculateDistanceBetweenPoints,
	calculatePathDistance,
	debugActive,
	dijkstra,
	encodeUUIDToBase64,
	findChildGroups,
	findComponentsWithSettings,
	findLocationToAnotherBuilding,
	findPointInData,
	findPrimaryPath,
	generateConnections,
	getTime,
	getVectorFromTwoPoints,
	mapHasMatchingChildGroupPoint,
	qaActive
} from './lib';

import {
	ETL,
} from './ETL';

import {
	dlWayfindingMapDrag,
	dlWayfindingMapPinch,
	dlWayfindingMapReset,
	dlWayfindingZoomIn,
	dlWayfindingZoomOut,
} from './DataLayer.js';

import './wf.css';

const mapTransitionTime = 700;

class WayfindingComponent extends PureComponent {
	zoomOriginMode = 'center';
	MIN_ZOOM = 0.5;
	MAX_ZOOM = 6;
	constructor(props) {
		super(props);

		let activeSystem = '';
		let activeSystemPoint = '';
		let activeSystemGraphicGroup = '';
		let activeMap = '';
		let activeMapPointGroup = '';
		let campusMap = null;
		let graphicSettingsArr = [];
		this.hasPointRestrictions = false;

		const pendingUpdates = ETL(props.flatData);
		this.pendingUpdates = pendingUpdates;

		Object.entries(pendingUpdates).forEach(([m1Key, m1Data,]) => {
			if (m1Key.startsWith('system.')) {
				activeSystem = m1Key;

				Object.keys(m1Data).forEach((m2Key) => {
					if (m2Key.startsWith('wf_point.')) {
						activeSystemPoint = m2Key;
					}
				});

				Object.keys(m1Data).forEach((m2Key) => {
					if (m2Key.startsWith('wf_graphic_group.')) {
						activeSystemGraphicGroup = m2Key;
					}
				});
			}
		});

		Object.entries(pendingUpdates).forEach(([m1Key, m1Data,]) => {
			if (m1Key.startsWith('wf_point_group.')) {
				Object.keys(m1Data).forEach((m2Key) => {
					if (m2Key === activeSystemPoint) {
						activeMapPointGroup = m1Key;
					}
				});
			}

			if (m1Key === activeSystemGraphicGroup) {
				Object.keys(m1Data).forEach((m2Key) => {
					if (m2Key.startsWith('wf_graphic_ref.')) {
						graphicSettingsArr.push(m2Key);
					}
				});
			}
		});

		Object.entries(pendingUpdates).forEach(([m1Key, m1Data,]) => {
			if (m1Key.startsWith('wf_map_graphic.')) {
				Object.keys(m1Data).forEach((m2Key) => {
					if (m2Key === activeMapPointGroup) {
						activeMap = m1Key;
					}
				});
			}
		});

		Object.keys(pendingUpdates[props.systemGroupUUID]).forEach((m2Key) => {
			if (m2Key.startsWith('wf_map_graphic.') && pendingUpdates[m2Key].campus_map) {
				campusMap = m2Key;
			}
		});

		Object.entries(pendingUpdates).forEach(([m1Key, m1Data,]) => {
			if (m1Key.startsWith('wf_point.')) {
				Object.keys(m1Data).forEach((m2Key) => {
					if (m2Key.startsWith('point_restriction')) {
						let value = JSON.parse(pendingUpdates[m1Key][m2Key]);
						if (value && value.length > 0 && value.includes('ADA')) {
							this.hasPointRestrictions = true;
						}
					}
				});
			}
		});

		const system = `system.${props.systemUUID}`;
		const config = pendingUpdates?.[system].configuration || {};
		const backgroundColor = pendingUpdates[config]?.background_color || '#ffffff';

		const mapGraphics = pendingUpdates?.[activeMap]?.source;
		const settings = findComponentsWithSettings(props.flatData, ["show_nearby_locations", "show_labels"]);

		this.wayfindingRef = {
			setZoom: (z) => console.log('Zoom set to:', z),
		};

		this.activeMap = activeMap;
		this.activeSystem = activeSystem;
		this.campusMap = campusMap;
		this.activeMapImage = mapGraphics;
		this.useNearbyLocation = '';

		this.state = {
			activePath: null,
			adaEnabled: props.adaActive || false,
			backgroundColor,
			currentMap: this.activeMap,
			currentSystem: this.activeSystem,
			endLocationMap: null,
			graphicSettingsArr: [],
			locationMarker: <></>,
			imageLoaded: false,
			mapIndex: 0,
			mapImage: this.activeMapImage,
			mapKey: null,
			matchingLocations: [],
			pathsIndex: 0,
			pathsObj: {},
			message: null,
			pathsObj: {},
			showInstructions: false,
			showInstructionsIndex: 0,
			showLabels: settings.show_labels,
			showNearbyLocations: settings.show_nearby_locations,
			landmarkIdentifier: props.landmarkIdentifier,
			landmarkIdentifierFallback: props.landmarkIdentifierFallback,
			legacyBuildingName: props.legacyBuildingName,
			legacyLandmarkId: props.legacyLandmarkId,
			legacyLocationName: props.legacyLocationName,
			listingConfigUUID: props.listingConfigUUID,
			listingUUID: props.listingUUID,
			useNearbyLocation: '',
			zoom: 1,
			showZoomBtns: props.wayfindingZoomPan,
			translateX: 0,
			translateY: 0,
			mapContainerWidth: 0,
			mapContainerHeight: 0,
		};

		this.connections = {};
		this.locationFound = false; // prevents location from re-calculating
		this.mapHasLoadedOnce = false; // prevents map from reloading
		this.mapsWithPointLocations = {};
		this.setAnimationFrameId = null;
		this.mapImg = React.createRef();
		this.canvas = React.createRef();
		this.mapContainerRef = React.createRef();
		this.modalRef = React.createRef(); // For #wayfindingModal
		this.canvasScrollCont = React.createRef();
		this.wayfindingContainer = React.createRef();
		this.activeMap = activeMap;
		this.activeSystem = activeSystem;
		this.addEndMarker = this.addEndMarker.bind(this);
		this.buildAdjacencyMap = this.buildAdjacencyMap.bind(this);
		this.buildGraphicSettingsArr = this.buildGraphicSettingsArr.bind(this);
		this.buildGroupPathData = this.buildGroupPathData.bind(this);
		this.buildMapGroupArray = this.buildMapGroupArray.bind(this);
		this.buildPathNetwork = this.buildPathNetwork.bind(this);
		this.buildQRCodeURL = this.buildQRCodeURL.bind(this);
		this.buildThreeMapPhasesData = this.buildThreeMapPhasesData.bind(this);
		this.clearCanvas = this.clearCanvas.bind(this);
		this.clearTimers = this.clearTimers.bind(this);
		this.constructBuildingData = this.constructBuildingData.bind(this);
		this.createFirstMapEntry = this.createFirstMapEntry.bind(this);
		this.createIntermediateMapEntry = this.createIntermediateMapEntry.bind(this);
		this.createLastMapEntry = this.createLastMapEntry.bind(this);
		this.createNearbyResults = this.createNearbyResults.bind(this);
		this.displayLocationMarker = this.displayLocationMarker.bind(this);
		this.drawLine = this.drawLine.bind(this);
		this.drawPath = this.drawPath.bind(this);
		this.filterData = this.filterData.bind(this);
		this.findAccessPoints = this.findAccessPoints.bind(this);
		this.findEndLocation = this.findEndLocation.bind(this);
		this.findNearestPoints = this.findNearestPoints.bind(this);
		this.findPointsWithLocation = this.findPointsWithLocation.bind(this);
		this.findRoutesFormatted = this.findRoutesFormatted.bind(this);
		this.findShortestPath = this.findShortestPath.bind(this);
		this.findThenDrawShortestPath = this.findThenDrawShortestPath.bind(this);
		this.findVerticalTransport = this.findVerticalTransport.bind(this);
		this.forceUpdate = this.forceUpdate.bind(this);
		this.getAllKeyValuesAsArray = this.getAllKeyValuesAsArray.bind(this);
		this.getAllPendingDataKeyValuesAsArray = this.getAllPendingDataKeyValuesAsArray.bind(this);
		this.getClosestNode = this.getClosestNode.bind(this);
		this.getLocation = this.getLocation.bind(this);
		this.getMapData = this.getMapData.bind(this);
		this.getParentKeyNameFromTarget = this.getParentKeyNameFromTarget.bind(this);
		this.handleImageLoad = this.handleImageLoad.bind(this);
		this.isLocationInSameBuildingAsSystem = this.isLocationInSameBuildingAsSystem.bind(this);
		this.isVariable = this.isVariable.bind(this);
		this.loadingMessage = this.loadingMessage.bind(this);
		this.matchingLocationsUI = this.matchingLocationsUI.bind(this);
		this.preloadNextMap = this.preloadNextMap.bind(this);
		this.reloadImage = this.reloadImage.bind(this);
		this.renderGraphics = this.renderGraphics.bind(this);
		this.renderLocationMarker = this.renderLocationMarker.bind(this);
		this.renderPathOnMap = this.renderPathOnMap.bind(this);
		this.resetMapIfNoPath = this.resetMapIfNoPath.bind(this);
		this.resetToInitialMap = this.resetToInitialMap.bind(this);
		this.rotatePoints = this.rotatePoints.bind(this);
		this.setListingsAndGetLocation = this.setListingsAndGetLocation.bind(this);
		this.setUseNearbyLocation = this.setUseNearbyLocation.bind(this);
		this.showMessage = this.showMessage.bind(this);
		this.showNextMap = this.showNextMap.bind(this);
		this.showQRCode = this.showQRCode.bind(this);
		this.stopAnimation = this.stopAnimation.bind(this);
		this.transformRoutesToCollections = this.transformRoutesToCollections.bind(this);
		this.transitionInstructions = this.transitionInstructions.bind(this);
		this.isDragging = false;
		this.startX = 0;
		this.startY = 0;
		this.initialDistance = 0;
		this.wayfindingModalResizeObserver = null;
	}

	componentDidMount() {
		const {
			setToInitialMap,
		} = this.props;

		requestAnimationFrame(() => {
			const container = this.wayfindingContainer.current;
			if (container) {
				container.addEventListener('mousedown', this.handleMouseDown);
				container.addEventListener('touchstart', this.handleTouchStart);

				window.addEventListener('mousemove', this.handleMouseMove);
				window.addEventListener('mouseup', this.handleMouseUp);

				window.addEventListener('touchmove', this.handleTouchMove);
				window.addEventListener('touchend', this.handleTouchEnd);

				window.addEventListener('orientationchange', this.handleOrientationChange);
			}
		});

		this.initMapConfig();
		if (this.props.isMobile) {
			this.initResizeObserver();
		}
		this.updateTransform(); // Apply initial transform
		
		this.clearTimers();
		this.connections = generateConnections(this.pendingUpdates);
		if (setToInitialMap) {
			this.resetToInitialMap();
			this.setMobileDefaultMapLocations();
		} else {
			this.getLocation();
		}
	}

	componentWillUnmount() {
		const container = this.wayfindingContainer.current;
		if (container) {

			container.removeEventListener('mousedown', this.handleMouseDown);
			container.removeEventListener('touchstart', this.handleTouchStart);

			window.removeEventListener('mousemove', this.handleMouseMove);
			window.removeEventListener('mouseup', this.handleMouseUp);

			window.removeEventListener('touchmove', this.handleTouchMove);
			window.removeEventListener('touchend', this.handleTouchEnd);

			window.removeEventListener('orientationchange', this.handleOrientationChange);
		}

		if (this.wayfindingModalResizeObserver && this.modalRef.current) {
			this.wayfindingModalResizeObserver.unobserve(this.modalRef.current);
		}
		
		clearTimeout(this.mapDelayTimer);
		clearTimeout(this.pathDelayTimer);
		this.stopAnimation();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.listingUUID !== prevProps.listingUUID ||
			this.state.useNearbyLocation !== prevState.useNearbyLocation ||
			!this.deepComparison(this.state.mapsWithPointLocations, prevState.mapsWithPointLocations)) {
			clearTimeout(this.mapDelayTimer);
			clearTimeout(this.pathDelayTimer);

			this.stopAnimation();
			this.clearCanvas();

			this.locationFound = false; // prevents location from re-calculating
			this.mapHasLoadedOnce = false; // prevents map from reloading
			this.setAnimationFrameId = null;

			this.setState({
				activeMap: this.activeMap,
				currentMap: this.activeMap,
				currentPath: [],
				graphicSettingsArr: [],
				imageLoaded: false,
				locationMarker: <></>,
				mapIndex: 0,
				mapImage: '',
				pathsIndex: 0,
				pathsObj: {},
				message: null,
				showInstructions: false,
				showInstructionsIndex: 0
			}, () => {
				this.getLocation();
			});
		}

	}

	deepComparison(obj1, obj2) {
		if (obj1 === obj2) return true;
		if (obj1 == null || obj2 == null) return false;
		if (typeof obj1 !== typeof obj2) return false;
		if (typeof obj1 !== 'object') return obj1 === obj2;
		
		const keys1 = Object.keys(obj1);
		const keys2 = Object.keys(obj2);
		
		if (keys1.length !== keys2.length) return false;
		
		for (let key of keys1) {
			if (!keys2.includes(key) || !this.deepComparison(obj1[key], obj2[key])) {
				return false;
			}
		}
		
		return true;
	}

	setListingsAndGetLocation({
		// runs from mobile only
		legacyBuildingName,
		legacyLandmarkId,
		legacyLocationName,
		listingUUID,
		listingConfigUUID,
		landmarkIdentifier,
		landmarkIdentifierFallback,
		primaryWayfindingColumn,
		secondaryWayfindingColumn
	}) {
		this.clearTimers();

		if (window.mobileOrientation === 'vertical') {
			this.stopAnimation();
			this.clearCanvas();

			this.mapHasLoadedOnce = false; // prevents map from reloading
			this.setAnimationFrameId = null;

			this.setState({
				activeMap: this.activeMap,
				currentMap: this.activeMap,
				currentPath: [],
				currentSystem: this.activeSystem,
				graphicSettingsArr: [],
				hideMap: true,
				imageLoaded: false,
				legacyBuildingName,
				legacyLandmarkId,
				legacyLocationName,
				listingUUID,
				listingConfigUUID,
				landmarkIdentifier,
				landmarkIdentifierFallback,
				locationMarker: <></>,
				mapIndex: 0,
				mapImage: '',
				message: null,
				pathsIndex: 0,
				pathsObj: {},
				primaryWayfindingColumn,
				secondaryWayfindingColumn,
				showInstructions: false,
				showInstructionsIndex: 0,
			}, () => {
				setTimeout(() => {
					this.getLocation();
				}, 50);
				setTimeout(() => {
					this.setState({
						hideMap: false,
					});
				}, 100);
			});
		} else {
			this.setState({
				imageLoaded: false,
				locationMarker: <></>,
				showInstructions: false,
				showInstructionsIndex: 0,
			}, () => {
				setTimeout(() => {
					this.stopAnimation();
					this.clearCanvas();

					this.setState({
						currentMap: this.activeMap,
						legacyBuildingName,
						legacyLandmarkId,
						legacyLocationName,
						listingUUID,
						listingConfigUUID,
						landmarkIdentifier,
						landmarkIdentifierFallback,
						message: null,
						primaryWayfindingColumn,
						secondaryWayfindingColumn,
					}, () => {
						this.getLocation();
						setTimeout(() => {
							this.reloadImage();
						}, 50);
					});
				});
			});
		}
	}

	resetMapIfNoPath() {
		const {
			pathsObj,
		} = this.state;

		if (Object.keys(pathsObj).length === 0) {
			this.resetToInitialMap();
		}
	}

	resetToInitialMap() {
		// only runs from mobile - wayfinding.js
		const {
			activeMap,
			activeSystem,
		} = this;

		const orientation = window.mobileOrientation || 'horizontal';
		
		this.clearTimers();
		let locationMarker = document.getElementById('locationMarker');
		if (locationMarker) {
			document.getElementById('locationMarker').style.opacity = 0;
		}

		this.setState({
			imageLoaded: false,
			locationMarker: <></>,
			message: null,
			showInstructions: false,
			showInstructionsIndex: 0,
		}, () => {
			this.mapTransitionTimer = setTimeout(() => {
				this.stopAnimation();
				this.clearCanvas();

				this.mapHasLoadedOnce = false;
				let mapGraphics = this.activeMapImage;
				let imageLoaded = true;

				if (orientation === 'vertical') {
					mapGraphics = '';
					imageLoaded = false;
				}

				this.setState({
					activePath: null,
					currentMap: activeMap,
					currentSystem: activeSystem,
					endLocationMap: null,
					landmarkIdentifier: this.props.landmarkIdentifier,
					landmarkIdentifierFallback: this.props.landmarkIdentifierFallback,
					legacyBuildingName: this.props.legacyBuildingName,
					legacyLandmarkId: this.props.legacyLandmarkId,
					legacyLocationName: this.props.legacyLocationName,
					listingConfigUUID: this.props.listingConfigUUID,
					listingUUID: this.props.listingUUID,
					imageLoaded,
					mapIndex: 0,
					mapImage: mapGraphics,
					mapKey: null,
					pathsObj: {},
				}, () => {
					this.buildGraphicSettingsArr(this.activeSystem, this.activeMap);
				});
			}, 100);
		});
	}

	handleImageLoad(callback) {
		const {
			mapIndex,
		} = this.state;

		if (!this.mapHasLoadedOnce) {
			this.mapHasLoadedOnce = true;
			clearTimeout(this.mapDelayTimer);
			clearTimeout(this.pathDelayTimer);

			callback();

			this.setState({ 
				imageLoaded: true,
				mapKey: `num${Math.random()}`, // force image reload
			}, () => {
				if (!this.locationFound && mapIndex === 0) {
					this.getLocation();
					this.locationFound = true;
				}
			});
		}
	}

	clearTimers() {
		clearTimeout(this.mapDelayTimer);
		clearTimeout(this.mapTransitionTimer);
		clearTimeout(this.pathDelayTimer);
	}

	preloadNextMap() {
		const {
			mapIndex,
			pathsObj,
		} = this.state;

		const nextMapIndex = mapIndex + 1;
		const nextMapGraphic = pathsObj?.[`map_${nextMapIndex}`]?.wf_map_graphic || null;
		const mapSrc = this.pendingUpdates[nextMapGraphic]?.source;

		if (mapSrc) {
			this.setState({
				preloadImage: mapSrc,
			});
		}
	}

	reloadImage() {
		const {
			activeSystem,
		} = this;

		const {
			currentMap,
			landmarkIdentifier,
			landmarkIdentifierFallback,
			legacyBuildingName,
			legacyLandmarkId,
			legacyLocationName,
			listingUUID,
			message,
			pathsObj,
		} = this.state;

		if (!landmarkIdentifier &&
			!landmarkIdentifierFallback &&
			!legacyBuildingName &&
			!legacyLandmarkId &&
			!legacyLocationName &&
			!listingUUID) {
			return;
		}

		if (message) {
			console.warn('Wayfinding: Cannot reload image while message is displayed. Path not found.');
			return;
		}

		this.clearTimers();

		this.setState({
			imageLoaded: false,
			locationMarker: <></>,
			showInstructions: false,
			showInstructionsIndex: 0,
		}, () => {
			this.mapTransitionTimer = setTimeout(() => {
				this.stopAnimation();
				this.clearCanvas();

				this.mapHasLoadedOnce = false;
				const mapObj = pathsObj?.map_0?.wf_map_graphic;
				const mapGraphics = this.pendingUpdates?.[mapObj]?.source;
	
				this.setState({
					currentMap: this.activeMap,
					currentSystem: activeSystem,
					mapImage: mapGraphics,
					mapIndex: 0,
					mapKey: `num${Math.random()}`, // force image reload
				}, () => {
					this.buildGraphicSettingsArr(activeSystem, currentMap);
				});
			}, mapTransitionTime);
		});
	}

	findAccessPoints(apGroupName) {
		const {
			pendingUpdates,
		} = this;

		if (!apGroupName || !pendingUpdates.hasOwnProperty(apGroupName)) {
			return false;
		}
	
		for (const key in pendingUpdates[apGroupName]) {
			if (key.startsWith("wf_map_ap_group.") && pendingUpdates[key]) {
				for (const subKey in pendingUpdates[key]) {
					if (subKey.startsWith("wf_point.")) {
						return true;
					}
				}
			}
		}
	
		return false;
	}

	getLocation() {
		const {
			activeSystem,
			activeMap,
			pendingUpdates,
		} = this;

		const {
			landmarkIdentifier,
			landmarkIdentifierFallback,
			legacyBuildingName,
			legacyLandmarkId,
			legacyLocationName,
			listingUUID,
		} = this.state;

		if (!landmarkIdentifier &&
			!landmarkIdentifierFallback &&
			!legacyBuildingName &&
			!legacyLandmarkId &&
			!legacyLocationName &&
			!listingUUID) {
			return;
		}

		const configuration = pendingUpdates?.[activeSystem]?.configuration;
		const activeSystemGroup = this.getParentKeyNameFromTarget('system_group', activeMap) || '';

		if (!configuration) {
			return;
		}

		let pathNetworkObj = {
			campusMap: null,
			endLocationMap: activeMap,
			hasAccessPoints: false,
			locationAndMapArr: [],
			pointIsOnCampusMap: false,
			systemGroupMapArray: [activeMap],
		};

		let locationName = legacyLandmarkId;

		// replace location with the landmarkId if it exists
		locationName = legacyLocationName ? legacyLocationName : locationName;
		
		const listingLandmarkIdentifier = (landmarkIdentifier || '').toLowerCase();
		const listingLandmarkIdentifierFallback = (landmarkIdentifierFallback || '').toLowerCase();
		let locationFallbackAndMapArr = [];

		// create an array of maps which belong to the same system group (Property)
		const hasVtGroup = pendingUpdates?.[pathNetworkObj.endLocationMap]?.map_vt_group;
		const hasApGroup = pendingUpdates?.[pathNetworkObj.endLocationMap]?.map_ap_group;
		
		if (hasVtGroup || hasApGroup) {
			pathNetworkObj.systemGroupMapArray = this.getAllKeyValuesAsArray(pendingUpdates?.[activeSystemGroup], 'wf_map_graphic');
		}

		pathNetworkObj.systemGroupMapArray.forEach((map) => { // for each map that belongs to the same property group
			const isCampusMap = pendingUpdates[map].campus_map;
			const isPrimaryMap = pendingUpdates[map].primary_map || false;
			const hasApGroup = pendingUpdates?.[map]?.map_ap_group;
			pathNetworkObj.hasAccessPoints = this.findAccessPoints(hasApGroup) === true ? true : pathNetworkObj.hasAccessPoints;

			if (isCampusMap) {
				pathNetworkObj.campusMap = map;
			}

			const newMapPointsName = pendingUpdates[map].map_points;
			const newMapPointsGroup = pendingUpdates[newMapPointsName];

			for (let pointName of Object.keys(newMapPointsGroup)) { // for each point in the map points group
				if (pendingUpdates[pointName]) { // verify point exists in data
					let useLocation = false;
					let useFallback = false;
					let wayfindingPoint = false;
					let pointInfo = {}; 

					// build obj to store multiple column values
					for (let pointObj of Object.keys(pendingUpdates[pointName])) { // for each of the point's keys
						if (pointObj && pointObj === 'location_array') {
							pointInfo.locationArray = JSON.parse(pendingUpdates[pointName].location_array);
							wayfindingPoint = true;
						}
						if (pointObj && pointObj.startsWith('listing_column_type.')) { // find the listing_column_type
							let columnType = pendingUpdates[pointObj].display_name;
							let objValue = pendingUpdates[pointName][pointObj].value;
	
							pointInfo[columnType] = objValue;
							wayfindingPoint = true;
						}
					}

					if (!wayfindingPoint) {
						continue;
					}

					// supports older setups, to match location and building fields
					let generatedPointLandmarkID = '';
					if (pointInfo['Location (apt/suite)']) {
						generatedPointLandmarkID = pointInfo['Location (apt/suite)'].toLowerCase();
						if (pointInfo['Building']) {
							generatedPointLandmarkID = `${pointInfo['Building']}-${pointInfo['Location (apt/suite)']}`.toLowerCase();
						}
					}

					// OLD: support for using only older data, pre-listingLandmarkIdentifier
					if (!listingLandmarkIdentifier && !listingLandmarkIdentifierFallback) {
						const buildingCondition = (!pointInfo['Building'] || pointInfo['Building'].toLowerCase() === legacyBuildingName.toLowerCase());
						const locationCondition = (!pointInfo['Location (apt/suite)'] || pointInfo['Location (apt/suite)'].toLowerCase() === locationName.toLowerCase() || pointInfo['Location (apt/suite)'] === 'ALL');

						if (buildingCondition && locationCondition && (pointInfo['Building'] || pointInfo['Location (apt/suite)'])) {
							useLocation = true;
						}
					} else {
						// NEW: if location_array exist on the point, use those values to match the stored value in the database
						// match listing to points via Landmark ID - wayfinding points with ALL are also matched
						for (const keyname of Object.keys(pointInfo)) {
							if (keyname === 'locationArray' && Array.isArray(pointInfo.locationArray) && pointInfo.locationArray.length > 0 && listingLandmarkIdentifier) {
								const lowercaseLocationArray = pointInfo.locationArray.map(location => location.toLowerCase());
								if (lowercaseLocationArray.includes(listingLandmarkIdentifier)) {
									useLocation = true;
								} else if (listingLandmarkIdentifierFallback && lowercaseLocationArray.includes(listingLandmarkIdentifierFallback)) {
									useFallback = true;
								}
							} else if ((keyname === 'Location (apt/suite)' || keyname === 'Building') && listingLandmarkIdentifier === generatedPointLandmarkID) {
								useLocation = true;
							}
						}
					}

					if (useLocation) {
						pathNetworkObj.endLocationMap = map; // building matches or building fields have been ignored
						const locationObj = {
							map,
							pointName,
							pointIsOnCampusMap: pathNetworkObj.pointIsOnCampusMap,
							isPrimaryMap,
						};
						if (isCampusMap) {
							pathNetworkObj.pointIsOnCampusMap = true;
							locationObj.pointIsOnCampusMap = true;
						}
						pathNetworkObj.locationAndMapArr.push(locationObj);
					}

					if (useFallback) {
						const locationFallbackObj = {
							map,
							pointName,
							pointIsOnCampusMap: pathNetworkObj.pointIsOnCampusMap,
							isPrimaryMap
						};
						if (isCampusMap) {
							locationFallbackObj.pointIsOnCampusMap = true;
						}
						locationFallbackAndMapArr.push(locationFallbackObj);
					}
				}
			}
		});

		if (Array.isArray(pathNetworkObj.locationAndMapArr)) {
			if (pathNetworkObj.locationAndMapArr.length > 1) {
				console.log(`Wayfinding: Multiple locations [${pathNetworkObj.locationAndMapArr.length}] were found matching Building:${legacyBuildingName}, Location:${locationName}.`);
			} else if (pathNetworkObj.locationAndMapArr.length === 0 && (Array.isArray(locationFallbackAndMapArr) && locationFallbackAndMapArr.length > 0)) {
				pathNetworkObj.locationAndMapArr = locationFallbackAndMapArr;
				pathNetworkObj.endLocationMap = locationFallbackAndMapArr[0].map;
				pathNetworkObj.pointIsOnCampusMap = locationFallbackAndMapArr[0].pointIsOnCampusMap;
				console.log(`Wayfinding: ${locationFallbackAndMapArr.length} Fallback locations were found matching Building:${legacyBuildingName}, Location:${locationName}.`);
			}
		}

		this.buildPathNetwork(pathNetworkObj);
	}

	getAllKeyValuesAsArray(targetData, targetName) { // ie: return all of a properties/system_group's systems
		let matchingArr = [];
	
		if (targetData && targetName) {
			for (let keyName of Object.keys(targetData)) {
				if (keyName.startsWith(targetName)) {
					matchingArr.push(keyName);
				}
			}
		}
		return matchingArr;
	}

	getParentKeyNameFromTarget(targetName, matchingValue) {
		let parentName = '';
    
		for (let m1KeyName of Object.keys(this.pendingUpdates)) {
			if (m1KeyName.startsWith(targetName)) {
				for (let m2KeyName of Object.keys(this.pendingUpdates[m1KeyName])) {
					if (m2KeyName === matchingValue) {
						parentName = m1KeyName;
						break;
					}
				}
				
				if (parentName) {
					break;
				}
			}
		}
		
		return parentName;
	}

	showMessage(message) {
		const {
			css,
		} = this.props;

		const {
			activeMap,
			activeSystem,
		} = this;

		const messageContainer = (
			<div className={`${css.wayfindingMsgCont} wayfindingMsgCont`}>
				<span className={`${css.wayfindingMsgText} wayfindingMsgText`}>{message}</span>
			</div>
		);

		setTimeout(() => {
			this.clearTimers();
			this.stopAnimation();
			this.clearCanvas();

			this.setState({
				activePath: null,
				currentMap: activeMap,
				currentSystem: activeSystem,
				endLocationMap: null,
				imageLoaded: true,
				mapIndex: 0,
				mapImage: this.activeMapImage,
				mapKey: null,
				message: messageContainer,
				pathsObj: {},
			}, () => {
				this.buildGraphicSettingsArr(activeSystem, activeMap);
			});
		}, mapTransitionTime);
	}

	findEndLocation(locationAndMapArr, systemPoint, campusMap, systemGroupMapArray, endLocationMap, hasAccessPoints) {
		const {
			activeMap,
			pendingUpdates,
		} = this;

		let locationData = {
			vtMapArrays: {}
		};
		let apChildGroupArr = null;
		let locationInSameBuildingAsSystem = false;
		let twoVtTransitionMap = '';
		let apTransitionMap = '';
		const mapPointsName = pendingUpdates[activeMap].map_points;
		const mapPointsGroup = pendingUpdates[mapPointsName];
		let mapWithChildGroupsAndPoints = {};
		let endingVtMapArr = [];

		// find the system on the current/starting map
		let systemPointFound = findPointInData(mapPointsGroup, systemPoint);
		if (!systemPointFound) {
			return;
		}

		if (Array.isArray(locationAndMapArr) && locationAndMapArr.length >= 1) {
			// First check if any location is on the same map as the system
			// If found, use it regardless of Primary Map status
			locationAndMapArr.forEach((locationObj) => {
				let locationOnSystemMap = findPointInData(mapPointsGroup, locationObj.pointName);
				if (locationOnSystemMap) {
					locationData.pointFoundOnSystemFloor = true;
					this.findThenDrawShortestPath(activeMap, systemPoint, locationObj.pointName, locationObj.map);
					return;
				}
			});

			// If no location is found on the same map, then consider Primary Map status
			if (!locationData.pointFoundOnSystemFloor) {
				// Find Primary Map if it exists
				const primaryMapLocation = locationAndMapArr.find(loc => loc.isPrimaryMap);

				// Handle same building scenario with Access Points
				if (hasAccessPoints) {
					// Prioritize primary map if it exists and we're not on the same floor
					const locationToProcess = primaryMapLocation ? [primaryMapLocation] : locationAndMapArr;

					locationToProcess.forEach((locationObj) => {
						if (!locationData.pointFoundInSystemBuilding) {
							const parentVtGroup = pendingUpdates[activeMap].map_vt_group || pendingUpdates[locationObj.map].map_vt_group;
							if (!parentVtGroup) {
								console.log(`Wayfinding: No VT group found for ${locationObj.map}.`);
							}

							const parentVtGroupObj = pendingUpdates?.[parentVtGroup];
							const vtChildGroupArr = findChildGroups(parentVtGroupObj, 'wf_map_vt_group.');
							const startApGroup = pendingUpdates[activeMap].map_ap_group;
							const startApGroupObj = pendingUpdates?.[startApGroup];
							apChildGroupArr = findChildGroups(startApGroupObj, 'wf_map_ap_group.') || null;
	
							const constructedBuilingData = this.constructBuildingData(systemGroupMapArray, vtChildGroupArr, locationObj.map);
							mapWithChildGroupsAndPoints = constructedBuilingData.mapWithChildGroupsAndPoints;
							endingVtMapArr = constructedBuilingData.endingVtMapArr;
							locationData.vtMapArrays[locationObj.map] = endingVtMapArr;

							// find maps that share the same wf_map_vt_groups as the system map
							const mapData = this.isLocationInSameBuildingAsSystem(
								mapWithChildGroupsAndPoints,
								locationObj.map,
								constructedBuilingData.startingVtMapArr,
								endingVtMapArr,
								campusMap,
							);
	
							locationInSameBuildingAsSystem = mapData.locationInSameBuildingAsSystem;
							twoVtTransitionMap = mapData.twoVtTransitionMap;
							apTransitionMap = mapData.apTransitionMap;
	
							if (locationInSameBuildingAsSystem) {
								locationData.pointFoundInSystemBuilding = true;
								locationData.endLocationMap = locationObj.map;
								locationData.endLocationPoint = locationObj.pointName;
							}
						}
					});
				}

				// Handle paths outside the building
				if (!locationData.pointFoundInSystemBuilding && hasAccessPoints) {
					const primaryData = findPrimaryPath(locationAndMapArr);
					locationData.primaryTargetPoint = primaryData.primaryTargetPoint;
					locationData.primaryLocationMap = primaryData.primaryLocationMap;

					for (const key in locationData.vtMapArrays) {
						if (key === primaryData.primaryLocationMap) {
							locationData.primaryVtMapArray = locationData.vtMapArrays[key];
						}
					}
				}

				// Handle Map Connectors scenario
				if (!hasAccessPoints) {
					// Prioritize primary map if it exists
					const locationToProcess = primaryMapLocation ? [primaryMapLocation] : locationAndMapArr;

					locationToProcess.forEach((locationObj) => {
						const parentVtGroup = pendingUpdates[activeMap].map_vt_group || pendingUpdates[locationObj.map].map_vt_group;
						if (!parentVtGroup) {
							console.log(`Wayfinding: No VT group found for ${locationObj.map}.`);
						}

						const parentVtGroupObj = pendingUpdates?.[parentVtGroup];
						const vtChildGroupArr = findChildGroups(parentVtGroupObj, 'wf_map_vt_group.');

						const constructedBuilingData = this.constructBuildingData(systemGroupMapArray, vtChildGroupArr, locationObj.map);
						mapWithChildGroupsAndPoints = constructedBuilingData.mapWithChildGroupsAndPoints;
						endingVtMapArr = constructedBuilingData.endingVtMapArr;
						locationData.vtMapArrays[locationObj.map] = endingVtMapArr;

						const mapData = this.isLocationInSameBuildingAsSystem(
							mapWithChildGroupsAndPoints,
							locationObj.map,
							constructedBuilingData.startingVtMapArr,
							endingVtMapArr,
							campusMap,
						);

						const matchingPointGroups = this.getAllKeyValuesAsArray(pendingUpdates, 'wf_point_group.');
						let targetPointGroup = '';

						matchingPointGroups.forEach((pointGroupName) => {
							let pointGroup = pendingUpdates[pointGroupName];
							if (pointGroup[locationObj.pointName]) {
								targetPointGroup = pointGroupName;
							}
						});

						const endLocationMap = this.getParentKeyNameFromTarget('wf_map_graphic.', targetPointGroup);
						const routesObj = this.findRoutesFormatted(this.connections, activeMap, endLocationMap);

						if (Object.keys(routesObj).length > 0) {
							locationInSameBuildingAsSystem = mapData.locationInSameBuildingAsSystem;
							twoVtTransitionMap = mapData.twoVtTransitionMap;
	
							locationData.pointFoundInSystemBuilding = true;
							locationData.endLocationMap = locationObj.map;
							locationData.endLocationPoint = locationObj.pointName;
							locationData.routes = routesObj;
						}
					});
				}
			}
		}

		return { locationData, apChildGroupArr, locationInSameBuildingAsSystem, twoVtTransitionMap, apTransitionMap, mapWithChildGroupsAndPoints, endingVtMapArr };
	};

	getMapData(keyname) {
		const {
			pathsObj
		} = this.state;

		if (!pathsObj || !pathsObj[`map_0`]) {
			return;
		}

		let minusIndex = 1;
		if (pathsObj?.totalDistance) {
			minusIndex = 2;
		}
		
		let value = pathsObj[`map_${Object.keys(pathsObj).length - minusIndex}`][keyname];
		const pathPoints = pathsObj.map_0.pathArr;
		
		if (!value && Array.isArray(pathPoints) && pathPoints.length > 0) {
			value = pathPoints[pathPoints.length - 1];
		}

		return value;
	}

	renderLocationMarker(canvasTop, canvasLeft) {
		const {
			currentMap,
		} = this.state;

		const {
			css,
		} = this.props;

		let {
			locationMarkerUse,
			locationMarkerColor,
			locationMarkerSize,
		} = this.props;

		locationMarkerColor = locationMarkerColor || 'red';
		locationMarkerSize = locationMarkerSize || 100;

		// PLACEHOLDER: replace endPoint to use this.state.activePath to show marker inside building
		const endPoint = this.getMapData('end');

		if (!endPoint || !locationMarkerUse) {
			return;
		}

		const locationCoordinateX = this.pendingUpdates?.[endPoint].x;
		const locationCoordinateY = this.pendingUpdates?.[endPoint].y;
		const rotatedValues = this.rotatePoints(currentMap, locationCoordinateX, locationCoordinateY);
		const markerOuterStyle = {
			width: `${locationMarkerSize}px`,
			height: `${locationMarkerSize}px`,
			border: `solid 2px ${locationMarkerColor}`,
		};
		const markerInnerStyle = {
			backgroundColor: locationMarkerColor,
		};
		const markerCenterSize = 10;
		const markerCenterStyle = {
			width: `${markerCenterSize}px`,
			height: `${markerCenterSize}px`,
			left: `${(locationMarkerSize / 2) - (markerCenterSize / 2)}px`,
			top: `${(locationMarkerSize / 2) - (markerCenterSize / 2)}px`,
			backgroundColor: locationMarkerColor,
		};

		const animatedMarker = (
			<>
				<div className={`${css.concentricCirclesCenter} concentricCirclesCenter`} style={markerCenterStyle}></div>
				<div className={`${css.concentricCircleOuter} ${css.concentricCircleOuter1} concentricCircleOuter concentricCircleOuter1`} style={markerOuterStyle}>
					<div className={`${css.concentricCircleInner} ${css.concentricCircleInner1} concentricCircleInner concentricCircleInner1`} style={markerInnerStyle}></div>
				</div>
				<div className={`${css.concentricCircleOuter} ${css.concentricCircleOuter2} concentricCircleOuter concentricCircleOuter2`} style={markerOuterStyle}>
					<div className={`${css.concentricCircleInner} ${css.concentricCircleInner2} concentricCircleInner concentricCircleInner2`} style={markerInnerStyle}></div>
				</div>
				<div className={`${css.concentricCircleOuter} ${css.concentricCircleOuter3} concentricCircleOuter concentricCircleOuter3`} style={markerOuterStyle}>
					<div className={`${css.concentricCircleInner} ${css.concentricCircleInner3} concentricCircleInner concentricCircleInner3`} style={markerInnerStyle}></div>
				</div>
				<div className={`${css.concentricCircleOuter} ${css.concentricCircleOuter4} concentricCircleOuter concentricCircleOuter4`} style={markerOuterStyle}>
					<div className={`${css.concentricCircleInner} ${css.concentricCircleInner4} concentricCircleInner concentricCircleInner4`} style={markerInnerStyle}></div>
				</div>
			</>
		);

		const markerDiv = (
			<div 
				className='locationMarker' 
				id='locationMarker'
				style={
					{
						position: 'absolute',
						top: `calc(${rotatedValues[1]}px + ${canvasTop} - ${locationMarkerSize / 2}px)`, 
						left: `calc(${rotatedValues[0]}px + ${canvasLeft} - ${locationMarkerSize / 2}px)`,
						height: `${locationMarkerSize}px`,
						width: `${locationMarkerSize}px`,
						transition: 'opacity .5s',
						zIndex: 1000
					}
				}>
				{animatedMarker}
			</div>
		)

		this.setState({
			locationMarker: markerDiv,
		});
	}

	buildPathNetwork({ campusMap, endLocationMap, hasAccessPoints, locationAndMapArr, pointIsOnCampusMap, systemGroupMapArray }) {
		if (!Array.isArray(locationAndMapArr) || locationAndMapArr.length === 0 || !locationAndMapArr[0]?.pointName) {
			this.showMessage('There is no wayfinding path for this listing');
			return;
		};

		let targetLocation = locationAndMapArr[0].pointName;

		this.setState({
			activePath: targetLocation,
			showInstructions: false,
			showInstructionsIndex: 0,
		});

		const {
			activeSystem,
			activeMap,
			pendingUpdates,
		} = this;

		const systemPoint = pendingUpdates[activeSystem].assigned;
		let newEndLocationMap = endLocationMap;
		let vtMapArr = [];

		const {
			locationData, 
			apChildGroupArr, 
			locationInSameBuildingAsSystem, 
			twoVtTransitionMap, 
			apTransitionMap, 
			mapWithChildGroupsAndPoints, 
		} = this.findEndLocation(locationAndMapArr, systemPoint, campusMap, systemGroupMapArray, endLocationMap, hasAccessPoints);

		if (locationData.pointFoundOnSystemFloor) {
			return;
		} else if (locationData.pointFoundInSystemBuilding) {
			endLocationMap = locationData.endLocationMap;
			newEndLocationMap = locationData.endLocationMap;
			targetLocation = locationData.endLocationPoint;
		} else if (locationData.primaryLocationMap && locationData.primaryTargetPoint) {
			newEndLocationMap = locationData.primaryLocationMap;
			targetLocation = locationData.primaryTargetPoint;
			vtMapArr = locationData.primaryVtMapArray;
		}

		// missing campus map
		if (!locationInSameBuildingAsSystem && !campusMap && hasAccessPoints) {
			console.error('Wayfinding: Connection between buildings cannot be made, there is no campus map.');
			return;
		}

		let secondFloorTransitionMap = null;
		// when system starts on the second floor of a building, it is not directly connected to the campus map via AP groups
		if (!locationInSameBuildingAsSystem && campusMap && !apChildGroupArr) {
			secondFloorTransitionMap = apTransitionMap;
		}
		
		// find ground floor, and determine if end location is not in the same building as the system
		const { finalEndLocationMap, finalEndLocationPoint, buildingGroundFloorMap } = findLocationToAnotherBuilding(
			mapWithChildGroupsAndPoints,
			campusMap,
			pointIsOnCampusMap,
			newEndLocationMap,
			targetLocation,
			locationInSameBuildingAsSystem,
			apChildGroupArr, 
			vtMapArr,
			apTransitionMap
		);

		let groupPointsObj = null;

		if (!hasAccessPoints) {
			const routesObj = locationData.routes;
			const collectionsObj = this.transformRoutesToCollections(
				routesObj,
				this.connections,
				activeMap,
				endLocationMap,
				systemPoint,
				targetLocation,
			);

			this.findShortestPath(collectionsObj, endLocationMap);
		} else {
			// Old method when using both APs and VTs (MCs)
			if (locationInSameBuildingAsSystem && twoVtTransitionMap) {
				groupPointsObj = this.buildGroupPathData(activeMap, endLocationMap, systemPoint, targetLocation, 'vt_group', campusMap, twoVtTransitionMap, null);
			} else if (locationInSameBuildingAsSystem) {
				groupPointsObj = this.buildGroupPathData(activeMap, endLocationMap, systemPoint, targetLocation, 'vt_group', campusMap, null, null);
			} else if (endLocationMap === campusMap && pointIsOnCampusMap && !secondFloorTransitionMap) {
				groupPointsObj = this.buildGroupPathData(activeMap, endLocationMap, systemPoint, targetLocation, 'ap_group', campusMap);
			} else if (campusMap && secondFloorTransitionMap) {
				groupPointsObj = this.buildGroupPathData(activeMap, finalEndLocationMap, systemPoint, finalEndLocationPoint, 'ap_group', campusMap, null, secondFloorTransitionMap);
			} else if (campusMap && apChildGroupArr) {
				groupPointsObj = this.buildGroupPathData(activeMap, finalEndLocationMap, systemPoint, finalEndLocationPoint, 'ap_group', campusMap, null, null, buildingGroundFloorMap);
			} else {
				console.error('Wayfinding: This location does not have a VT or AP group');
			}

			if (groupPointsObj) {
				this.findShortestPath(groupPointsObj, endLocationMap);
			}
		}
	}


	// Helper function to find the other map graphic ID in a connection
	getOtherMapGraphic(connection, currentMapGraphic) {
		const mapKeys = Object.keys(connection).filter(key => key.startsWith('wf_map_graphic.'));
		return mapKeys.find(key => key !== currentMapGraphic);
	};

	createFirstMapEntry(startMap, startPoint, firstConnection) {
		return {
			wf_map_graphic: startMap,
			instructions: "", // No instructions for first map
			group_name: `System to ${firstConnection.group_name}`,
			start: startPoint,
			end: firstConnection[startMap],
		};
	};

	// Create an intermediate map entry
	createIntermediateMapEntry(currentConnection, nextConnection, previousMapGraphic) {
		const currentMapGraphic = this.getOtherMapGraphic(currentConnection, previousMapGraphic);
		return {
			wf_map_graphic: currentMapGraphic,
			instructions: currentConnection.instructions, // Instructions from current connection
			group_name: `${currentConnection.group_name} to ${nextConnection ? nextConnection.group_name : "Location"}`,
			start: currentConnection[currentMapGraphic],
			end: nextConnection ? nextConnection[currentMapGraphic] : null
		};
	};

	createLastMapEntry(endMap, endPoint, lastConnection, previousMapGraphic) {
		return {
			wf_map_graphic: endMap,
			instructions: lastConnection.instructions,
			group_name: `${lastConnection.group_name} to Location`,
			start: lastConnection[endMap],
			end: endPoint
		};
	};

	// Main function to transform routes into collections
	transformRoutesToCollections(
		routesCollection,
		connections,
		startMap,
		endMap,
		startPoint,
		endPoint
	) {
		const result = {};

		Object.entries(routesCollection).forEach(([routeKey, connectionIds], index) => {
			const collection = {};
			const routeConnections = connectionIds.map(id => connections[id]);

			// Create first map entry
			collection.map_0 = this.createFirstMapEntry(
				startMap,
				startPoint,
				routeConnections[0]
			);

			// Create intermediate map entries
			let previousMapGraphic = startMap;
			routeConnections.forEach((connection, idx) => {
				if (idx === routeConnections.length - 1) return;
				
				const nextConnection = routeConnections[idx + 1];
				collection[`map_${idx + 1}`] = this.createIntermediateMapEntry(
					connection,
					nextConnection,
					previousMapGraphic
				);
				previousMapGraphic = collection[`map_${idx + 1}`].wf_map_graphic;
			});

			// Create last map entry
			const lastMapIndex = routeConnections.length;
			collection[`map_${lastMapIndex}`] = this.createLastMapEntry(
				endMap,
				endPoint,
				routeConnections[routeConnections.length - 1],
				previousMapGraphic
			);

			result[`collection_${index}`] = collection;
		});

		return result;
	};

	findRoutesFormatted(connections, startMap, endMap) {
		// Build adjacency map
		const adjacencyMap = this.buildAdjacencyMap(connections);
	
		const allRoutes = [];
		const visited = new Set();
	
		// Helper function to perform DFS iteratively with explicit stack
		const findPathsIterative = () => {
			const stack = [[startMap, [], new Set()]]; // [currentMap, path, usedVtGroups]
	
			while (stack.length > 0) {
				const [currentMap, path, usedVtGroups] = stack.pop();
	
				if (currentMap === endMap) {
					// Add a valid path to the result
					allRoutes.push([...path]);
					continue;
				}
	
				// Mark current map as visited
				visited.add(currentMap);
	
				// Process neighbors
				const neighbors = adjacencyMap[currentMap] || [];
				for (const [nextMap, connectionId] of neighbors) {
					if (!visited.has(nextMap)) {
						const vtGroupName = connections[connectionId]?.vt_group_name;
						if (!usedVtGroups.has(vtGroupName)) {
							// Create new state for the next iteration
							const newPath = [...path, connectionId];
							const newUsedVtGroups = new Set(usedVtGroups);
							newUsedVtGroups.add(vtGroupName);
	
							stack.push([nextMap, newPath, newUsedVtGroups]);
						}
					}
				}
	
				// Unmark current map for backtracking
				visited.delete(currentMap);
			}
		}

		findPathsIterative();
	
		// Format the output
		const result = {};
		allRoutes.forEach((route, index) => {
			result[`route_${index}`] = route;
		});
	
		return result;
	};
	
	buildAdjacencyMap(connections) {
		const adjacencyMap = {};
	
		// Process each connection
		Object.entries(connections).forEach(([connectionId, connection]) => {
			// Identify maps connected by this connection
			const maps = Object.keys(connection).filter((key) =>
				key.startsWith('wf_map_graphic.')
			);
	
			const [map1, map2] = maps;
	
			// Add bidirectional edges
			if (!adjacencyMap[map1]) adjacencyMap[map1] = [];
			if (!adjacencyMap[map2]) adjacencyMap[map2] = [];
	
			adjacencyMap[map1].push([map2, connectionId]);
			adjacencyMap[map2].push([map1, connectionId]);
		});
	
		return adjacencyMap;
	};

	isLocationInSameBuildingAsSystem(mapWithChildGroupsAndPoints, newEndLocationMap, startingVtMapArr, endingVtMapArr, campusMap) {
		const {
			pendingUpdates,
		} = this;
		
		let locationInSameBuildingAsSystem = false;
		let apTransitionMap = '';
		const campusApGroup = pendingUpdates?.[campusMap]?.map_ap_group;
		const campusApGroupObj = pendingUpdates?.[campusApGroup];
		const campusApChildGroupArr = findChildGroups(campusApGroupObj, 'wf_map_ap_group.') || null;
		
		let allBuildingMaps = []
		for (let map of Object.keys(mapWithChildGroupsAndPoints)) {
			for (let vtGroup of startingVtMapArr) {
				for (let mapVtGroup of Object.keys(mapWithChildGroupsAndPoints[map])) {
					if (vtGroup === mapVtGroup && !allBuildingMaps.includes(map)) {
						allBuildingMaps.push(map);

						const startApGroup = pendingUpdates[map].map_ap_group;
					
						if (startApGroup) {
							const startApGroupObj = pendingUpdates?.[startApGroup];
							const apChildGroupArr = findChildGroups(startApGroupObj, 'wf_map_ap_group.') || null;
		
							// check each item in the apChildGroupArr array, for a match with each item in the campusApChildGroupArr array
							if (apChildGroupArr && campusApChildGroupArr) {
								for (let apGroup of apChildGroupArr) {
									for (let campusApGroup of campusApChildGroupArr) {
										if (apGroup === campusApGroup) {
											apTransitionMap = map;
										}
									}
								}
							}
						}
					}
				}

				if (newEndLocationMap === map && mapWithChildGroupsAndPoints[map][vtGroup]) {
					locationInSameBuildingAsSystem = true;
				}
			}

			for (let vtGroup of endingVtMapArr) {
				for (let mapVtGroup of Object.keys(mapWithChildGroupsAndPoints[map])) {
					if (vtGroup === mapVtGroup && !allBuildingMaps.includes(map)) {
						allBuildingMaps.push(map);
					}
				}
			}
		}

		// multi VT transition, if a map has the same vt groups as the system map, and the end location map, find it
		let twoVtTransitionMap = '';

		if (!locationInSameBuildingAsSystem && allBuildingMaps.length >= 2) {
			for (let map of Object.keys(mapWithChildGroupsAndPoints)) {
				let mapStartVt = false
				let matchEndVt = false

				
				if (allBuildingMaps.includes(map)) {
					for (let vtGroup of startingVtMapArr) {
						for (let mapVtGroup of Object.keys(mapWithChildGroupsAndPoints[map])) {
							if (vtGroup === mapVtGroup) {
								mapStartVt = true;
							}
						}
					}
					for (let vtGroup of endingVtMapArr) {
						for (let mapVtGroup of Object.keys(mapWithChildGroupsAndPoints[map])) {
							if (vtGroup === mapVtGroup) {
								matchEndVt = true;
							}
						}
					}

					if (mapStartVt && matchEndVt) {
						locationInSameBuildingAsSystem = true;
						twoVtTransitionMap = map;
					}
				}
			}
		}

		return { locationInSameBuildingAsSystem, twoVtTransitionMap, apTransitionMap };
	}

	constructBuildingData(systemGroupMapArray, vtChildGroupArr, newEndLocationMap) {
		if (!systemGroupMapArray) {
			console.error('Wayfinding: Cannot find building maps. Check VT group setup between maps.');
			return;
		}

		const {
			activeMap,
			pendingUpdates,
		} = this;
		
		// build array of maps that share the same child VT groups as the system map or endLocationMap
		let mapWithChildGroupsAndPoints = {};
		let startingVtMapArr = [];
		let endingVtMapArr = [];

		systemGroupMapArray.forEach((map) => {
			const currentMapPointsGroup = pendingUpdates[map].map_points;
			const currentMapPointsGroupObj = pendingUpdates[currentMapPointsGroup];
			const mapApGroup = pendingUpdates[map].map_ap_group;
			const mapApGroupObj = pendingUpdates?.[mapApGroup];
			const mapApChildGroupArr = findChildGroups(mapApGroupObj, 'wf_map_ap_group.') || null;

			if (currentMapPointsGroupObj) {								
				for (let point of Object.keys(currentMapPointsGroupObj)) { // loop over map's wf_point_group
					if (vtChildGroupArr) {
						// for each map, use child VT groups to check for any groups that are shared
						vtChildGroupArr.forEach((vtGroup) => { // loop over each child VT group
							const vtGroupObj = pendingUpdates?.[vtGroup];
							
							for (let vtPoint of Object.keys(vtGroupObj)) {
								if (vtPoint.startsWith('wf_point')) {
	
									// build formatted data
									if (vtPoint === point) {
										if (!mapWithChildGroupsAndPoints[map]) {
											mapWithChildGroupsAndPoints[map] = {};
										}
										mapWithChildGroupsAndPoints[map][vtGroup] = vtPoint;
									}
	
									// store the child VT group that matches the system map
									if (vtPoint === point && map === activeMap) {
										startingVtMapArr.push(vtGroup);
									}
									
									// store the child VT group that matches the end location map
									if (vtPoint === point && map === newEndLocationMap) {
										endingVtMapArr.push(vtGroup);
									}
								}
							}
						});
					}

					if (mapApChildGroupArr) {
						// for each map, use child AP groups to check for any groups that are shared
						mapApChildGroupArr.forEach((apGroup) => { // loop over each child VT group
							const apGroupObj = pendingUpdates?.[apGroup];
							
							for (let apPoint of Object.keys(apGroupObj)) {
								if (apPoint.startsWith('wf_point')) {
	
									// build formatted data
									if (apPoint === point) {
										if (!mapWithChildGroupsAndPoints[map]) {
											mapWithChildGroupsAndPoints[map] = {};
										}
										mapWithChildGroupsAndPoints[map][apGroup] = apPoint;
									}
								}
							}
						});
					}
				}
			}
		})

		return { mapWithChildGroupsAndPoints, startingVtMapArr, endingVtMapArr };
	}

	buildMapGroupArray(currentMap, groupType, secondFloorTransitionMap) {
		const {
			pendingUpdates,
		} = this;
		
		let mapGroupArr = [];
		
		if (secondFloorTransitionMap) {
			const mapGroupApName = pendingUpdates[currentMap][`map_ap_group`];
			const mapGroupVtName = pendingUpdates[currentMap][`map_vt_group`];
			const mapApGroupObj = pendingUpdates[mapGroupApName];
			const mapVtGroupObj = pendingUpdates[mapGroupVtName];
			
			if (mapApGroupObj) {
				mapGroupArr.push(mapApGroupObj);
			}

			if (mapVtGroupObj) {
				mapGroupArr.push(mapVtGroupObj);
			}
		} else {
			const mapApOrVtGroupName = pendingUpdates[currentMap][`map_${groupType}`];
			const mapApOrVtGroupObj = pendingUpdates[mapApOrVtGroupName];
			mapGroupArr = [mapApOrVtGroupObj];
		}

		return mapGroupArr;
	}

	buildGroupPathData(mapStart, endLocationMap, systemPoint, targetLocation, groupType, campusMap, transitionMap, secondFloorTransitionMap, buildingGroundFloorMap) {		
		const {
			pendingUpdates,
		} = this;
		
		let mapsArr = transitionMap ? [mapStart, transitionMap, endLocationMap] : [mapStart, endLocationMap];
		mapsArr = secondFloorTransitionMap ? [mapStart, secondFloorTransitionMap, endLocationMap] : mapsArr;
		let routeOptionsObj = {};
		let isCampusMapOnly = false;

		// if starting map is the same as the campus map
		if (mapStart === campusMap) {
			isCampusMapOnly = true;
		}

		mapsArr.forEach((currentMap, i) => {
			let mapGroupArr = this.buildMapGroupArray(currentMap, groupType, secondFloorTransitionMap);

			if (!Array.isArray(mapGroupArr) || (Array.isArray(mapGroupArr) && mapGroupArr.length === 0) || (Array.isArray(mapGroupArr) && mapGroupArr[0] === undefined)) {
				console.error(`Wayfinding: Cannot configure building data. In the wayfinding tool, check that AP group and VT group data connect maps correctly!`);
				return;
			}

			// when campus map only, skip other maps
			if (currentMap !== campusMap && isCampusMapOnly) {
				return;
			}

			mapGroupArr.forEach((mapGroupObj) => {
				if (!mapGroupObj) {
					console.error('Wayfinding: Missing Data, mapGroupObj not found!');
					return;
				}

				for (let m1Key of Object.keys(mapGroupObj)) {

					let useApAndVtGroups = false;
					if (secondFloorTransitionMap && (m1Key.startsWith(`wf_map_ap_group`) || m1Key.startsWith(`wf_map_vt_group`))) {
						useApAndVtGroups = true;
					}

					if (useApAndVtGroups || m1Key.startsWith(`wf_map_${groupType}.`)) {
						const childGroupName = pendingUpdates[m1Key].display_name;
						let dataName = m1Key.split('.')[0];
						let groupTypeLabel = dataName.split('wf_map_')[1];
	
						
						// if a AP or VT Group's point exists in the currentMap point group, loop over child AP or VT Group to find points
						for (let m2Key of Object.keys(pendingUpdates[m1Key])) {
	
							// create initial data if it doesn't exist
							if (!routeOptionsObj[`${m1Key}`]) {
								routeOptionsObj[`${m1Key}`] = {};
							}
							if (!routeOptionsObj[`${m1Key}`][`map_${i}`]) {
								routeOptionsObj[`${m1Key}`][`map_${i}`] = {
									wf_map_graphic: currentMap
								};
								if (!routeOptionsObj[`${m1Key}`][`map_${i}`]['group_name']) {
									routeOptionsObj[`${m1Key}`][`map_${i}`]['group_name'] = childGroupName;
								}
							}
	
							if (m2Key.startsWith('wf_point.')) { // point found, only child groups have points
								const mapPointsName = pendingUpdates[currentMap].map_points; // name of the wf_point_group.uuid
								const pointDataObj = pendingUpdates[mapPointsName]; // obj wf_point_group.uuid from the system's map
								const groupPointFound = findPointInData(pointDataObj, m2Key); // AP or VT point found in the currentMap point group
	
								// find the AP child group that belongs to the end location's map, and the group point that matches this map
								if (currentMap === endLocationMap && groupPointFound) {
									routeOptionsObj[`${m1Key}`][`map_${i}`][`${groupTypeLabel}_name`] = m1Key;
									routeOptionsObj[`${m1Key}`][`map_${i}`][`${groupTypeLabel}_point`] = m2Key;
								}
	
								// build path data for multiple child VT Groups
								if (isCampusMapOnly && groupPointFound) {
									routeOptionsObj[`${m1Key}`][`map_${i}`]['start'] = systemPoint;
									routeOptionsObj[`${m1Key}`][`map_${i}`]['end'] = m2Key;
								} else if (!isCampusMapOnly && groupPointFound) {
									routeOptionsObj[`${m1Key}`][`map_${i}`]['instructions'] = this.pendingUpdates[m1Key]?.instruction_text || '';

									if (i === 0) {
										routeOptionsObj[`${m1Key}`][`map_${i}`]['start'] = systemPoint;
										routeOptionsObj[`${m1Key}`][`map_${i}`]['end'] = m2Key;
									} else {
										routeOptionsObj[`${m1Key}`][`map_${i}`]['start'] = m2Key;
										routeOptionsObj[`${m1Key}`][`map_${i}`]['end'] = targetLocation;
									}
								}
								
							}
						}
					}
				}
			});
		});

		const filteredData = this.filterData(routeOptionsObj, isCampusMapOnly, buildingGroundFloorMap);

		if (transitionMap) {
			// create path data for multiple VT Groups that don't exist on all floors (ie: Elevator A for floors 1-3, then Elevator B for floors 3-6)
			const threePhasesObj = this.buildThreeMapPhasesData(filteredData, 'vt');
			return threePhasesObj;
		} else if (secondFloorTransitionMap) {
			// create path from a second floor system map to the campus map
			const threePhasesObj = this.buildThreeMapPhasesData(filteredData, 'ap');
			return threePhasesObj
		} else {
			return filteredData;
		}
	}

	filterData(routeOptionsObj, isCampusMapOnly, buildingGroundFloorMap) {
		// cleanup map data, remove routes that cannot be calculated
		Object.entries(routeOptionsObj).forEach(([groupKey, groupObj]) => {
			Object.entries(groupObj).forEach(([map, mapObj]) => {
				if (!mapObj.start || !mapObj.end) {
					delete groupObj[map];
				}
				// ifCampusMap, match or remove the AP group
				if (isCampusMapOnly && map === 'map_0') {
					const endMapHasMatchingChildGroupPoint = mapHasMatchingChildGroupPoint(this.pendingUpdates, buildingGroundFloorMap, groupKey);
					if (!endMapHasMatchingChildGroupPoint) {
						delete routeOptionsObj[groupKey];
					}
				}
			});
			// if isCampusMapOnly, remove the 2nd map
			if (isCampusMapOnly) {
				delete groupObj['map_1'];
			}
			// remove empty vtgroups
			if (Object.keys(groupObj).length === 0) {
				delete routeOptionsObj[groupKey];
			}
			// remove AP groups that don't have 2 maps
			if (Object.keys(groupObj).length !== 2 && !isCampusMapOnly) {
				delete routeOptionsObj[groupKey];
			}
		});

		return routeOptionsObj;
	}

	buildThreeMapPhasesData(routeOptionsObj, type) {
		const {
			pendingUpdates,
		} = this;
		
		let threePhasesRouteObj = {};
		let collectionIndex = 0;
		let startMaps = Object.entries(routeOptionsObj).filter(([key, value]) => !value.map_2);
		let endMaps = Object.entries(routeOptionsObj).filter(([key, value]) => !value.map_0);

		// create collections with variations for each start and end map
		startMaps.forEach(([startKey, startValue]) => {
			endMaps.forEach(([endKey, endValue]) => {
				let transitionEndVtPoint = '';
				let groupObj = pendingUpdates[endValue.map_2[`${type}_group_name`]];
				
				Object.entries(groupObj).forEach(([key, value]) => {
					if (key.startsWith('wf_point') && key !== endValue.map_2[`${type}_group_point`]) {
						transitionEndVtPoint = key;
					}
				});

				let collection = {
					map_0: startValue.map_0,
					map_1: {
						...startValue.map_1,
						group_name: `${startValue.map_1.group_name} to ${endValue.map_1.group_name}`,
						end: transitionEndVtPoint
					},
					map_2: endValue.map_2
				};

				threePhasesRouteObj['collection_' + collectionIndex] = collection;
				collectionIndex++;
			});
		});

		return threePhasesRouteObj;
	}

	findShortestPath(vtPointsObj, endLocationMap) {
		// pathing across more than one map
		const {
			pendingUpdates,
		} = this;

		const {
			currentMap,
			currentSystem,
		} = this.state;

		let calculatedVtPointsObj = vtPointsObj;

		for (let m1Key of Object.keys(vtPointsObj)) {
			let totalDistance = 0;
			for (let m2Key of Object.keys(vtPointsObj[m1Key])) {
				let pathArr = dijkstra(pendingUpdates, vtPointsObj[m1Key][m2Key].wf_map_graphic, vtPointsObj[m1Key][m2Key]['start'], vtPointsObj[m1Key][m2Key]['end'], this.state.adaEnabled);
				let distance = 0;

				if (!pathArr || !Array.isArray(pathArr) || (Array.isArray(pathArr) && pathArr.length === 0)) {
					distance = Infinity;
				} else {
					distance = calculatePathDistance(pendingUpdates, pathArr);
				}
				
				totalDistance += distance;
				calculatedVtPointsObj[m1Key][m2Key]['distance'] = distance;
				calculatedVtPointsObj[m1Key][m2Key]['pathArr'] = pathArr;
			}
			calculatedVtPointsObj[m1Key]['totalDistance'] = totalDistance;
		}

		console.log('calculatedVtPointsObj', calculatedVtPointsObj);

		let minDistance = Infinity;
		let minDistanceElevator = null;
		
		for (let vtGroup in calculatedVtPointsObj) {
			if (calculatedVtPointsObj.hasOwnProperty(vtGroup)) {
				let totalDistance = calculatedVtPointsObj[vtGroup].totalDistance;
				if (totalDistance < minDistance) {
					minDistance = totalDistance;
					minDistanceElevator = vtGroup;
				}
			}
		}

		if (minDistance === Infinity && !minDistanceElevator) {
			this.showMessage('There is no wayfinding path for this listing');
			return;
		}

		this.locationFound = true;

		this.setState({
			endLocationMap,
			mapIndex: 0,
			mapImage: this.pendingUpdates?.[currentMap]?.source,
			mapKey: `num${Math.random()}`, // force image reload
			pathsObj: calculatedVtPointsObj[minDistanceElevator],
		}, () => {
			this.buildGraphicSettingsArr(currentSystem, currentMap);
			this.findPointsWithLocation(calculatedVtPointsObj[minDistanceElevator]);
		});
	}

	getMobilePrimaryWayfindingColumn = () => {
		if (this.state?.primaryWayfindingColumn) {
			return `listing_column.${this.state.primaryWayfindingColumn}`;
		}
		
		const fd = this.pendingUpdates;
		let listingUUID = this.state.listingUUID;

		if (!listingUUID) {
			const primaryListingCollection = window.newData.nav[0].collection || '';
			const dataName = window.newData.nav[0].dataName || '';
			const wfColumn = window.newData[primaryListingCollection].listing_groups[dataName].listings[0].tierConfig.wfColumn;
			return `listing_column.${wfColumn}`;
		}
			
		let primaryWayfindingColumn = '';
		for (let [m1Key, m1Data] of Object.entries(fd)) {
			if (m1Key.startsWith('listing_group.')) {
				for (let [m2Key, m2Data] of Object.entries(m1Data)) {
					if (m2Key.startsWith('listing_config.')) {
						if (listingUUID && m2Data.wf_column && fd?.[listingUUID]?.[`listing_column.${m2Data.wf_column}`]) {
							primaryWayfindingColumn = `listing_column.${m2Data.wf_column}`;
							console.log(`Primary wayfinding column set to: ${primaryWayfindingColumn}`);
						}
					}
				}
			}
		}
		return primaryWayfindingColumn;
	}

	getPrimaryWayfindingColumnKey() {
		if (this.props.isMobile) {
			return this.getMobilePrimaryWayfindingColumn();
		}
		return `listing_column.${this.props.primaryWayfindingColumn}`;
	}

	getMobileListingNameColumn() {
		const defaultLabelCol = this.getPrimaryWayfindingColumnKey();
		let listingNameCol = null;
		
		// Try to find the column in window.etlData (first approach)
		if (window.etlData) {
			try {
				outerLoop:
				for (const listingCollection of Object.values(window.etlData)) {
					if (!listingCollection.listing_groups) continue;
					
					for (const listingGroup of Object.values(listingCollection.listing_groups)) {
						if (!listingGroup.listings) continue;
						
						for (const listing of Object.values(listingGroup.listings)) {
							if (!listing.rawCols || !listing.colGroups || listing.colGroups.length === 0) continue;
							
							for (const [key, value] of Object.entries(listing.rawCols)) {
								if (key === defaultLabelCol) {
									listingNameCol = listing.colGroups[0].m1Key;
									break outerLoop;
								}
							}
						}
					}
				}
			} catch (e) {
				console.warn('Error in getMobileListingNameColumn with etlData:', e);
			}
		}

		// If the column wasn't found in etlData, try newData (second approach)
		if (!listingNameCol && window.newData && window.newData.nav && window.newData.nav.length > 0) {
			try {
				const primaryListingCollection = window.newData.nav[0].collection || '';
				
				if (primaryListingCollection && window.newData[primaryListingCollection] && 
					window.newData[primaryListingCollection].listing_groups) {
					
					outerLoop:
					for (const listingGroup of Object.values(window.newData[primaryListingCollection].listing_groups)) {
						if (!listingGroup.listings) continue;
						
						for (const listing of Object.values(listingGroup.listings)) {
							if (!listing.rawCols || !listing.colGroups || listing.colGroups.length === 0) continue;
							
							for (const [key, value] of Object.entries(listing.rawCols)) {
								if (key === defaultLabelCol) {
									listingNameCol = listing.colGroups[0].m1Key;
									break outerLoop;
								}
							}
						}
					}
				}
			} catch (e) {
				console.warn('Error in getMobileListingNameColumn with newData:', e);
			}
		}

		// Fallback to window.listingNameCol if it exists
		if (!listingNameCol && window.listingNameCol) {
			listingNameCol = window.listingNameCol;
		}

		return listingNameCol;
	}

	processLocationPoints(mapLocationPoints, listingNameCol = null) {
		const fd = this.pendingUpdates;
		const primaryWayfindingColumn = this.getPrimaryWayfindingColumnKey();
		let pointsWithLocation = {};

		for (const locPt in mapLocationPoints) {
			if (fd[locPt]) {
				const point = fd[locPt];
				
				if (point.location_array || 
					Object.keys(point).some(k => k.startsWith('listing_column_type.'))) {
				
					pointsWithLocation[locPt] = {
						...point,
						id: locPt.replace('wf_point.', ''),
						x: point.x,
						y: point.y
					};

					// If location_array exists, parse it from string to array
					if (point.location_array) {
						try {
							pointsWithLocation[locPt].locations = JSON.parse(point.location_array);
						} catch (e) {
							console.warn(`Failed to parse location_array for ${locPt}`);
							pointsWithLocation[locPt].locations = [];
						}
					}

					this.addLocationNames(pointsWithLocation, locPt, primaryWayfindingColumn, listingNameCol);
				}
			}
		}

		return pointsWithLocation;
	}

	addLocationNames(pointsWithLocation, locPt, primaryWayfindingColumn, listingNameCol) {
		const fd = this.pendingUpdates;

		for (let [m1Key, value] of Object.entries(fd)) {
			if (m1Key.startsWith('listing.') && 
				fd[m1Key][primaryWayfindingColumn] && 
				fd[m1Key][primaryWayfindingColumn].string) {

				const locationString = fd[m1Key][primaryWayfindingColumn].string.toLowerCase();
				
				const locationsArr = pointsWithLocation[locPt].locations || [];
				if (locationsArr.some(loc => loc.toLowerCase() === locationString)) {
					for (let [m2Key, m2Data] of Object.entries(fd[m1Key])) {
						if (m2Key.startsWith('listing_column.') && 
							m2Key !== primaryWayfindingColumn) {
							
							if (this.props.isMobile) {
								if (listingNameCol && m2Key === listingNameCol) {
									pointsWithLocation[locPt].name = m2Data.string;
								} else if (!listingNameCol && m2Key === window.listingNameCol) {
									pointsWithLocation[locPt].name = m2Data.string;
								}
							} else if (m2Key === this.props.listingNameCol) {
								pointsWithLocation[locPt].name = m2Data.string;
							}
						}
					}
					break;
				}
			}
		}
	}

	setMobileDefaultMapLocations() {
		const fd = this.pendingUpdates;
		const mapName = this.state.currentMap;
		
		if (this.state?.mapsWithPointLocations?.[mapName]) {
			console.log(`mapsWithPointLocations ${mapName} already exists`);
			return;
		}

		const listingNameCol = this.getMobileListingNameColumn();
		const mapGraphic = fd[mapName];
		const mapLocationPoints = fd[mapGraphic.map_locations];
		
		const pointsWithLocation = this.processLocationPoints(mapLocationPoints, listingNameCol);
		const mapsWithPointLocations = this.createMapsWithPointLocations(pointsWithLocation, this.state.currentMap);

		this.setState({
			mapsWithPointLocations
		});
	}

	findPointsWithLocation(pathsObj) {
		const {
			mapsWithPointLocations
		} = this;
		const fd = this.pendingUpdates;
		const lastKey = Object.keys(pathsObj).filter(key => key !== 'totalDistance').pop();
		const map = pathsObj[lastKey].wf_map_graphic;
		const mapLocationPoints = fd[fd[map].map_locations];
		let pointsWithLocation = {};

		Object.keys(pathsObj).forEach(key => {
			if (key.startsWith('map_') && pathsObj[key].wf_map_graphic) {
				const mapGraphicName = pathsObj[key].wf_map_graphic;
				const mapGraphic = fd[mapGraphicName];
				const locationGroup = fd[mapGraphic.map_locations];
				
				if (!mapsWithPointLocations?.[mapGraphicName]?.locations) {
					mapsWithPointLocations[mapGraphicName] = {
						'locations': locationGroup
					};
				}
			}
		});

		if (this.state?.mapsWithPointLocations?.[map]) {
			pointsWithLocation = this.state.mapsWithPointLocations[map];
		} else {
			pointsWithLocation = this.processLocationPoints(mapLocationPoints);
		}

		const targetPoint = this.getMapData('end');
		const targetPointData = fd[targetPoint];
		const nearestPoints = this.findNearestPoints(pointsWithLocation, targetPointData.x, targetPointData.y);
		this.createNearbyResults(nearestPoints, pointsWithLocation);
	}

	findNearestPoints(pointsWithLocation, targetX, targetY) {
		const pointsWithDistance = Object.entries(pointsWithLocation).map(([key, point]) => {
			// Calculate Euclidean distance: sqrt((x2-x1)² + (y2-y1)²)
			const distance = Math.sqrt(
				Math.pow(point.x - targetX, 2) + 
				Math.pow(point.y - targetY, 2)
			);

			return {
				key,
				point,
				distance
			};
		})
			.filter(item => item.point.name && item.distance !== 0);
		
		// Sort points by distance and take the first 'count' elements
		const nearestPoints = pointsWithDistance.sort((a, b) => a.distance - b.distance);
		
		// Format the results
		return nearestPoints.map(({ key, point, distance }) => ({
			id: key,
			x: point.x,
			y: point.y,
			distance: Math.round(distance * 100) / 100, // Round to 2 decimal places
			locations: point.locations || [],
			listingColumns: point.listingColumns || {}
		}));
	}

	createNearbyResults(nearestPoints, pointsWithLocation) {
		const count = 4;
		const fd = this.pendingUpdates;
		let matchingLocations = {};
		let primaryWayfindingColumn = `listing_column.${this.props.primaryWayfindingColumn}`;

		if (this.props.isMobile) {
			primaryWayfindingColumn = this.getMobilePrimaryWayfindingColumn();
		}

		for (let [key, value] of Object.entries(fd)) {
			if (key.startsWith('listing.') && fd[key]?.[primaryWayfindingColumn]?.string) {
				const locationString = fd[key][primaryWayfindingColumn].string.toLowerCase();
				
				for (let result of nearestPoints) {
					if (result.locations.some(loc => {
						return loc.toLowerCase() === locationString;
					})) {
						matchingLocations[key] = {
							landmarkId: fd[key][primaryWayfindingColumn].string,
							distance: result.distance,
							x: result.x,
							y: result.y,
							id: result.id,
						};

						for (let [m2Key, m2Data] of Object.entries(fd[key])) {
							if (m2Key.startsWith('listing_column.') && m2Key !== primaryWayfindingColumn) {
								if (this.props.isMobile && m2Key === window.listingNameCol) {
									matchingLocations[key] = {
										...matchingLocations[key],
										name: m2Data.string
									};
								} else if (!this.props.isMobile && m2Key === this.props.listingNameCol) {
									matchingLocations[key] = {
										...matchingLocations[key],
										name: m2Data.string
									};
								}
							}
						}
						// remove nearestPoint.result
						nearestPoints.splice(nearestPoints.indexOf(result), 1);
						break;
					}
				}
			}
		}

		const mapsWithPointLocations = this.createMapsWithPointLocations(pointsWithLocation, this.state.endLocationMap);
		const limitedMatchingLocations = this.createLimitedMatchingLocations(matchingLocations, count);

		this.setState({
			matchingLocations: limitedMatchingLocations,
			nearestPoints,
			pointsWithLocation, // Labels
			mapsWithPointLocations, // Labels
		});

		if (this.props.isMobile) {
			this.matchingLocationsMobileUI(limitedMatchingLocations);
		}
	}

	createMapsWithPointLocations(pointsWithLocation, mapForLabeling) {
		let mapsWithPointLocations = {};

		if (this.state?.mapsWithPointLocations) {
			mapsWithPointLocations = {
				...this.state.mapsWithPointLocations
			};
		}

		if (!this.state?.mapsWithPointLocations?.[mapForLabeling]) {
			mapsWithPointLocations[mapForLabeling] = pointsWithLocation;
		}
		return mapsWithPointLocations;
	}
	
	mobileListings = () => {
		try {
			const currentListObj = window.currentList;
			if (!currentListObj || typeof currentListObj !== 'object') {
				return [];
			};

			const listingsArr = currentListObj.listings;

			if (!Array.isArray(listingsArr)) {
				return [];
			};

			let newListings = [];

			listingsArr.forEach((listing) => {
				if (listing?.m1Key && typeof listing.m1Key === 'string' && listing.m1Key.startsWith('listing.')) {
					newListings.push(listing.m1Key);
				}
			});

			return newListings;
		} catch (e) {
			console.error('Error in mobileListings:', e);
			return [];
		}
	}

	createLimitedMatchingLocations(matchingLocations, count) {
		// remove locations that do not exist for the mobile listings currently being shown
		if (this.props.isMobile) {
			const mobileListings = this.mobileListings();
			const filteredLocations = Object.entries(matchingLocations).filter(([key]) => {
				return mobileListings.includes(key);
			});
			matchingLocations = Object.fromEntries(filteredLocations);
		}

		// Sort by distance and limit to 'count' items
		const limitedMatchingLocations = Object.entries(matchingLocations)
			.sort((a, b) => a[1].distance - b[1].distance)
			.slice(0, count)
			.reduce((obj, [key, value]) => {
				obj[key] = value;
				return obj;
			}, {});

		return limitedMatchingLocations;
	}

	showNextMap(keys) {
		const {
			mapIndex,
			pathsObj,
		} = this.state;

		if (mapIndex + 1 < keys.length) {
			this.setState({
				imageLoaded: false,
			}, () => {
				this.mapTransitionTimer = setTimeout(() => {
					this.clearCanvas();
					this.mapHasLoadedOnce = false;
					const mapGraphic = pathsObj?.[keys[mapIndex + 1]]?.wf_map_graphic;
					const imgSource = this.pendingUpdates?.[mapGraphic]?.source;

					this.setState({
						currentMap: mapGraphic,
						currentSystem: null,
						imageLoaded: false,
						mapImage: imgSource,
						mapIndex: mapIndex + 1,
					}, () => {
						this.buildGraphicSettingsArr(null, mapGraphic);
					});
				}, mapTransitionTime);
			});
		} else {
			console.log('renderAllPaths complete.');
		}
	}

	renderPathOnMap(canvasTop, canvasLeft) {
		const {
			locationMarkerUse,
		} = this.props;

		let {
			mapDelayIn
		} = this.props;

		mapDelayIn = mapDelayIn || 1.5;

		if (locationMarkerUse) {
			this.displayLocationMarker(canvasTop, canvasLeft);
			return;
		}

		const {
			pathsObj,
			mapIndex,
		} = this.state;

		this.stopAnimation();
		this.clearCanvas();

		if (!pathsObj) {
			this.showMessage('There is no wayfinding path for this listing');
			return;
		}

		// if totalDistance exists, remove it
		if (pathsObj.totalDistance) {
			delete pathsObj.totalDistance;
		}
		const keys = Object.keys(pathsObj);
		const pathDelaySeconds = mapDelayIn || 1.5;
		
		if (mapIndex < keys.length) {
			const m1Key = keys[mapIndex];
			
			if (m1Key.startsWith('map')) {
				this.clearTimers();
				
				this.pathDelayTimer = setTimeout(() => {
					this.setState({
						showInstructions: false,
					});
					this.drawPath(pathsObj[m1Key].wf_map_graphic, pathsObj[m1Key].pathArr, 5, 0, 0, () => {
						this.showNextMap(keys);
					});
				}, pathDelaySeconds * 1000);
			}
		}
	}

	findThenDrawShortestPath(currentMap, startPoint, targetLocation, endLocationMap) {
		// pathing between system and point on the same map
		this.stopAnimation();
		this.clearCanvas();

		// Use only state value to ensure toggle works regardless of props
		const shortestPath = dijkstra(this.pendingUpdates, currentMap, startPoint, targetLocation, this.state.adaEnabled);
		const pathsObj = {
			'map_0': {
				wf_map_graphic: currentMap,
				pathArr: shortestPath,
			},
		};

		if (!shortestPath || !Array.isArray(shortestPath) || (Array.isArray(shortestPath) && shortestPath.length === 0)) {
			this.showMessage('There is no wayfinding path for this listing');
			return;
		}

		this.locationFound = true;

		this.setState({
			endLocationMap,
			mapIndex: 0,
			mapImage: this.pendingUpdates?.[this.state.currentMap]?.source,
			pathsObj,
		}, () => {
			this.buildGraphicSettingsArr(this.state.currentSystem, this.state.currentMap);
			this.findPointsWithLocation(pathsObj);
		});
	}

	displayLocationMarker(canvasTop, canvasLeft) {
		this.stopAnimation();
		this.clearCanvas();

		if (!this.state.pathsObj || !this.state.pathsObj.map_0) {
			return;
		}

		const {
			activeMap,
			activeSystem,
		} = this;

		const {
			endLocationMap,
		} = this.state;
		
		let currentSystem = 'No System';
		if (endLocationMap === activeMap) {
			currentSystem = activeSystem;
		}

		// PLACEHOLDER: change lastMap to endLocationMap, to show marker inside building
		const lastMap = this.getMapData('wf_map_graphic');

		this.setState({
			currentSystem,
			currentMap: lastMap,
			mapIndex: 0,
			mapImage: this.pendingUpdates?.[lastMap]?.source,
			mapKey: `num${Math.random()}`, // force image reload
		}, () => {
			this.renderLocationMarker(canvasTop, canvasLeft);
			this.buildGraphicSettingsArr(currentSystem, lastMap);
		});
	}

	findVerticalTransport(map) {
		const mapVerticalTransportGroupName = this.pendingUpdates[map].map_vt_group; // name of the wf_point_group.
		const mapVerticalTransportGroupObj = this.pendingUpdates[mapVerticalTransportGroupName]; // obj wf_point_group. from the system's map
		
		// find paths to a single VT (future will support multiple VTs)
		let vtArray = [];
		for (let keyName of Object.keys(mapVerticalTransportGroupObj)) {
			if (keyName.startsWith('wf_point.')) {
				vtArray.push(keyName);
			}
		}

		// return the first VT found
		if (vtArray.length > 0) {
			return vtArray[0];
		} else {
			return null;
		}
	}

	// get the unvisited node with the shortest distance
	getClosestNode(distances, visited) {
		let closestNode = null;
		let shortestDistance = Infinity;
		for (const point in distances) {
			if (!visited[point] && distances[point] < shortestDistance) {
				closestNode = point;
				shortestDistance = distances[point];
			}
		}
		return closestNode;
	}

	addEndMarker(currentMap, vertices) {
		let {
			pathColor,
			pathEndmarker,
			pathEndmarkerSize,
			pathWidth,
		} = this.props;

		pathColor = pathColor || 'red';
		pathEndmarker = pathEndmarker || 'triangle';
		pathEndmarkerSize = pathEndmarkerSize || 15;
		pathWidth = pathWidth || 5;

		const pointDataName = this.pendingUpdates[currentMap].map_points;
		const pointData = this.pendingUpdates[pointDataName];

		const canvas = this.canvas;
		if (!canvas) {
			return;
		}
		const context = canvas?.current?.getContext('2d');
		if (!canvas.current) {
			return;
		}

		let start = [];
		let end = [];
		if (Array.isArray(vertices) && vertices.length >= 2) {
			start = pointData[vertices[vertices.length - 2]];
			end = pointData[vertices[vertices.length - 1]];
		}

		let rotateStart = this.rotatePoints(currentMap, start[0], start[1]);
		let rotateEnd = this.rotatePoints(currentMap, end[0], end[1]);

		const size = pathEndmarkerSize;
		const endMarkerType = pathEndmarker;

		context.beginPath();
		
		if (endMarkerType === 'circle') {
			context.arc(rotateEnd[0], rotateEnd[1], size / 2, 0, 2 * Math.PI);
		} else if (endMarkerType === 'square') {
			const side = size * Math.sqrt(2);
			context.rect(rotateEnd[0] - side / 2, rotateEnd[1] - side / 2, side, side);
		} else {
			// equalateral triangle for arrow
			context.moveTo(rotateEnd[0], rotateEnd[1]);
			let angle = Math.atan2(rotateEnd[1] - rotateStart[1], rotateEnd[0] - rotateStart[0]);
			const x1 = rotateEnd[0] - size * Math.cos(angle + Math.PI / 6);
			const y1 = rotateEnd[1] - size * Math.sin(angle + Math.PI / 6);
			const x2 = rotateEnd[0] - size * Math.cos(angle - Math.PI / 6);
			const y2 = rotateEnd[1] - size * Math.sin(angle - Math.PI / 6);
			context.lineTo(x1, y1);
			context.lineTo(x2, y2);
			context.closePath();
		}

		context.fillStyle = pathColor;
		context.strokeStyle = pathColor;
		context.lineWidth = pathWidth;
		context.stroke();		
		context.fill();		
	}

	drawPath(currentMap, vertices, drawingSpeed = 5, startingLength = 0, startingPointIndex = 0, callback) {
		let {
			mapDelayOut = 3,
		} = this.props;

		mapDelayOut = mapDelayOut || 3;

		const pointDataName = this.pendingUpdates[currentMap].map_points
		const pointData = this.pendingUpdates[pointDataName];

		const startName = vertices[startingPointIndex];
		const start = pointData[startName];

		const endName = vertices[startingPointIndex + 1];
		const end = pointData[endName];
		
		if (startingPointIndex + 1 >= vertices.length) {
			this.setState({
				showInstructions: true,
				showInstructionsIndex: this.state.showInstructionsIndex + 1,
			});

			this.addEndMarker(currentMap, vertices);

			if (typeof callback === 'function') {
				const mapDelaySeconds = mapDelayOut;
				clearTimeout(this.mapDelayTimer);
				this.mapDelayTimer = setTimeout(() => {
					callback();
				}, mapDelaySeconds * 1000);
			}

			return;
		}

		if (this.canvas.current) {
			this.drawLine(currentMap, start, end, drawingSpeed, startingLength => {
				const newIndex = startingPointIndex + 1;
				this.drawPath(currentMap, vertices, drawingSpeed, startingLength, newIndex, callback);
			}, startingLength);
		}
	}

	rotatePoints(currentMap, pointX, pointY) {
		const {
			activeSystem,
		} = this;

		let rotatedX = pointX;
		let rotatedY = pointY;

		const width = this.pendingUpdates[currentMap].canvas_width;
		const height = this.pendingUpdates[currentMap].canvas_height;

		const canvasWidth = parseInt(width);
		const canvasHeight = parseInt(height);
		let configuration = this.pendingUpdates[activeSystem].configuration;

		// campus map override
		if (this.state.currentMap === this.campusMap && (!this.state.currentSystem || this.state.currentSystem === 'No System')) {
			configuration = this.pendingUpdates[this.campusMap].configuration;
		}

		const rotation = parseInt(this.pendingUpdates[configuration].map_rotation);

		if (rotation === 90) {
			rotatedX = -pointY + canvasHeight;
			rotatedY = pointX;
		} else if (rotation === 180) {
			rotatedX = canvasWidth - pointX;
			rotatedY = canvasHeight - pointY;
		} else if (rotation === 270) {
			rotatedX = pointY;
			rotatedY = canvasWidth - pointX;
		}

		return [rotatedX, rotatedY]
	}

	drawLine(currentMap, startPoint, endPoint, drawingSpeed = 5, onAnimationEnd) {
		const canvas = this.canvas;
		if (!startPoint || !endPoint || !canvas) {
			return;
		}
		const context = canvas?.current?.getContext('2d');
		if (!canvas.current) {
			return;
		}

		let lastUpdate = getTime();
		const FRAME_DURATION = 1000 / 60; // 60fps frame duration ~16.66ms

		let currentPoint = startPoint;
		const vector = getVectorFromTwoPoints(startPoint, endPoint);
		const startToEndDistance = calculateDistanceBetweenPoints(startPoint, endPoint);
	  
		const lineStep = drawingSpeed / startToEndDistance;
	  
		let vectorStep = {
			x: vector.x * lineStep,
			y: vector.y * lineStep,
		};

		const animate = () => {
			let {
				pathColor,
				pathWidth,
			} = this.props;

			pathColor = pathColor || 'red';
			pathWidth = pathWidth || 5;

			const now = getTime();
			const delta = (now - lastUpdate) / FRAME_DURATION;
	  
			const deltaVector = {
				x: vectorStep.x * delta,
				y: vectorStep.y * delta
			};
	  
			let nextPoint = [currentPoint[0] + deltaVector.x, currentPoint[1] + deltaVector.y];
	  
			let newStartingLength = 0;
			let isFinished = false;
		
			const startToNextPointDistance = calculateDistanceBetweenPoints(startPoint, nextPoint);
		
			// The next point is past the end point
			if (startToNextPointDistance >= startToEndDistance) {
				newStartingLength = startToNextPointDistance - startToEndDistance;
				isFinished = true;
				nextPoint = endPoint;
			}

			let rotateCurrentPoints = this.rotatePoints(currentMap, currentPoint[0], currentPoint[1]);
			let rotateNextPoints = this.rotatePoints(currentMap, nextPoint[0], nextPoint[1]);

			// Draw line segment
			context.beginPath();
			context.moveTo(rotateCurrentPoints[0], rotateCurrentPoints[1]);
			context.lineTo(rotateNextPoints[0], rotateNextPoints[1]);
			context.lineCap = "round";
			context.lineJoin = "round";
			context.lineWidth = pathWidth;
			context.strokeStyle = pathColor;
			context.stroke();
	  
			if (isFinished) {
				if (onAnimationEnd) {
					onAnimationEnd(newStartingLength);
				}
				return;
			}
	  
			// Move current point to the end of the drawn segment
			currentPoint = nextPoint;
	  
			// Update last updated time
			lastUpdate = now;
		
			this.animationFrameId = requestAnimationFrame(animate);
		};
		this.animationFrameId = requestAnimationFrame(animate);
	}

	stopAnimation() {
		cancelAnimationFrame(this.animationFrameId);
		this.animationFrameId = null;
	}

	clearCanvas() {
		const canvas = this.canvas;
		
		try {
			const context = canvas.current.getContext('2d');
			let canvasWidth = canvas.current.width;
			let canvasHeight = canvas.current.height;
			context.clearRect(0, 0, canvasWidth, canvasHeight);
		} catch {
			console.error('Wayfinding: canvas not found');
		}
	}

	isVariable(color) {
		const {
			pendingUpdates,
		} = this;

		let newColor = color;
		if (color && color.startsWith('variable_color.')) {
			newColor = pendingUpdates.settings.color.value;
		}
		return newColor;
	}

	getAllPendingDataKeyValuesAsArray(targetData, targetName) { // ie: return all of a properties/system_group's systems
		let data = this.pendingUpdates?.[targetData];

		let matchingArr = [];
		if (data) {
			for (let keyName of Object.keys(data)) {
				if (keyName.startsWith(targetName)) {
					matchingArr.push(keyName);
				}
			}
		}
		return matchingArr;
	}

	buildGraphicSettingsArr(activeSystem, currentMap = this.activeMap) {
		const {
			currentSystem
		} = this.state;

		let graphicSettingsArr = [];

		let graphicParent = activeSystem;

		if (!currentSystem || currentSystem === 'No System') {
			graphicParent = currentMap;
		}
	
		let graphicsSystemCollection = this.getAllPendingDataKeyValuesAsArray(graphicParent, 'wf_graphic_group.');
		if (graphicsSystemCollection.length > 0) {
			graphicSettingsArr = this.getAllPendingDataKeyValuesAsArray(graphicsSystemCollection[0], 'wf_graphic_ref.');
		}
		this.setState({
			graphicSettingsArr,
		});
	}

	renderGraphics(graphicSettingsArr = [], configuration = null) {
		const {
			pendingUpdates,
		} = this;

		const {
			currentSystem,
			imageLoaded,
		} = this.state;

		const {
			css,
			env,
		} = this.props;

		let graphicsCollection = [];
		let refGraphic = null;
		const wfEnv = qaActive() === 1 ? 'ciprod' : env;

		graphicSettingsArr.forEach((setting) => {
			const graphicSettings = pendingUpdates[setting];
			const graphicConfiguration = graphicSettings.configuration;
			if ((!currentSystem || currentSystem === 'No System') &&
				(typeof graphicConfiguration === 'string' && typeof configuration === 'string' && graphicConfiguration !== configuration)) {
				return;
			}

			let baseGraphic = pendingUpdates[graphicSettings.graphic];
			let graphic = graphicSettings.graphic;
			let scale = graphicSettings.scale;
			let rotate = graphicSettings.rotate;
			let sort = graphicSettings.z_index;
			let customSettingClass = graphicSettings.custom_class || '';
			let customGraphicClass = pendingUpdates[graphic].custom_class || '';
			let transformValue = '';
			let top = graphicSettings.y;
			let left = graphicSettings.x;
			let isImage = graphicSettings.graphic.startsWith('wf_graphic_image.');
			let isText = graphicSettings.graphic.startsWith('wf_graphic_text.');
			let isIcon = graphicSettings.graphic.startsWith('wf_graphic_icon.');
			const imageIsLoaded = imageLoaded ? `${css.mapLoaded} mapLoaded` : `${css.mapLoading} mapLoading`;
			
			if (scale && (scale !== '1' && scale !== 0)) {
				transformValue += `scale(${scale})`;
			}
			if (rotate && rotate !== 0) {
				transformValue += ` rotate(${rotate}deg)`;
			}

			let style = {
				position: 'absolute',
				top: top || 0,
				left: left || 0,
				transform: transformValue,
				zIndex: sort
			};

			if (isImage) {
				style = {
					...style,
					width: `${baseGraphic.width}`
				};
				graphicsCollection.push(
					<img
						key={setting}
						ref={refGraphic}
						src={`https://ts-wayfinding.s3.amazonaws.com/${wfEnv}/${pendingUpdates[graphic].value}`}
						alt={`Img ${setting}`}
						className={`${customSettingClass} ${css.graphicImage} graphicImage ${customGraphicClass} ${imageIsLoaded}`}
						style={style}
					/>
				);
			} else if (isText) {
				const text = this.pendingUpdates[graphic].value;

				style = {
					...style,
					alignItems: baseGraphic.align_vert,
					background: this.isVariable(baseGraphic.background_color),
					border: `solid ${baseGraphic.wf_border_width} ${this.isVariable(baseGraphic.border_color)}`,
					borderRadius: `${baseGraphic.border_radius}`,
					color: this.isVariable(baseGraphic.color),
					display: "flex",
					fontSize: `${baseGraphic.size}`,
					fontWeight: baseGraphic.font_weight,
					height: `${baseGraphic.height}`,
					justifyContent: baseGraphic.align_horiz,
					lineHeight: baseGraphic.line_height,
					padding: baseGraphic.padding,
					textAlign: baseGraphic.text_align,
					width: `${baseGraphic.width}`,
				};

				graphicsCollection.push(
					<div
						key={setting}
						ref={refGraphic}
						alt={`Text ${setting}`}
						className={`${customSettingClass} ${css.graphicText} graphicText ${customGraphicClass} ${imageIsLoaded}`}
						style={style}
					>
						{text}
					</div>
				);
			} else if (isIcon) {
				style = {
					...style,
					alignItems: baseGraphic.align_vert,
					background: this.isVariable(baseGraphic.background_color),
					border: `solid ${baseGraphic.wf_border_width} ${this.isVariable(baseGraphic.border_color)}`,
					borderRadius: `${baseGraphic.border_radius}`,
					color: this.isVariable(baseGraphic.icon_color),
					display: "flex",
					filter: `${baseGraphic.filter}`,
					fontSize: `${baseGraphic.icon_size}`,
					height: `${baseGraphic.height}`,
					justifyContent: baseGraphic.align_horiz,
					padding: baseGraphic.padding,
					width: `${baseGraphic.width}`,
				};

				const icon = (
					<div 
						className={`${customSettingClass} ${css.graphicIcon} graphicIcon ${customGraphicClass} ${imageIsLoaded}`}
						key={setting}
						ref={refGraphic}
						style={style}
					>
						<Icons 
							alt={`Icon ${setting}`}
							fill={this.isVariable(baseGraphic.icon_color)}
							fill2={this.isVariable(baseGraphic.icon_color_2)}
							value={baseGraphic.value} 
						/>
					</div>
				);

				graphicsCollection.push(icon);
			}
		})

		return graphicsCollection;
	}

	buildQRCodeURL() {
		const {
			componentUUID,
			env,
			legacyLandmarkId,
		} = this.props;

		const {
			listingUUID,
		} = this.state;

		if (!listingUUID) {
			return '';
		}

		let qrCodeURL = 'https://www.touchsource.com';

		let subdomain = 'web';

		if (env !== 'ciprod') {
			subdomain = `web-${env}`;
		}

		let encodedSystemUUID = encodeUUIDToBase64(componentUUID.replace(/-/g, ''));
		let encodedListingUUID = encodeUUIDToBase64(listingUUID.split('.')[1].replace(/-/g, ''));

		let systemSection = `s=${btoa(encodedSystemUUID)}`;
		let listingSection = `&l=${btoa(encodedListingUUID)}`;

		let landmark_id = legacyLandmarkId || null;
		if (landmark_id) {
			listingSection = `&lid=${landmark_id}`;
		}

		qrCodeURL = `http://${subdomain}.touchsource.com/?${systemSection}${listingSection}`;

		return qrCodeURL;
	}

	showQRCode() {
		const {
			hideQRCode,
		} = this.props;

		if (hideQRCode) {
			return false;
		}

		const {
			listingConfigUUID,
		} = this.state;

		let pendingUpdates = this.pendingUpdates

		let showQRCode = true;

		for (let [m1Key, m1Data] of Object.entries(pendingUpdates)) {
			if (m1Key.startsWith('listing_group.')) {
				for (let [m2Key, m2Data] of Object.entries(m1Data)) {
					if (m2Key === listingConfigUUID) {
						showQRCode = m2Data.show_qrcode;
					}
				}
			}
		}

		return showQRCode;
	}

	loadingMessage(imageIsLoaded) {
		const {
			backgroundColor
		} = this.state;

		const {
			css,
		} = this.props;

		const style = {
			backgroundColor: backgroundColor || 'white',
		};

		return (
			<div className={`${css.loadingMessage} loadingMessage ${imageIsLoaded}`} style={style}>
				<div className={`${css.loadingIconCont} loadingIconCont`}>
					<FontAwesomeIcon className={`${css.loadingIcon} loadingIcon`} icon={faSpinner} />
				</div>
				<span className={`${css.loadingText} loadingText`}>
					Loading Map
				</span>
			</div>
		);
	}

	transitionInstructions() {
		const {
			css,
		} = this.props;

		const {
			showInstructions,
			showInstructionsIndex,
			pathsObj,
		} = this.state;

		const instructions = pathsObj?.[`map_${showInstructionsIndex}`]?.instructions;
		const mapName = pathsObj?.[`map_${showInstructionsIndex}`]?.wf_map_graphic;
		const mapDisplayName = this.pendingUpdates?.[mapName]?.map_name || '';
		const displayInstructions = instructions ? showInstructions : false;

		return (
			<div className={`wayfindingInstructions ${css.instructions} instructions ${displayInstructions ? `${css.showInstructions} showInstructions` : ''}`}>
				{instructions && `${instructions} ${mapDisplayName}`}
			</div>
		);
	}

	matchingLocationsUI(matchingLocations) {
		// matchingLocationsMobileUI is used for mobile, not this function
		const {
			css
		} = this.props;

		const {
			showNearbyLocations
		} = this.state;

		const displayClass = showNearbyLocations ? css.matchingLocationsShow : '';

		if (Object.keys(matchingLocations).length > 0) {
			return (
				<div className={`${css.matchingLocations} ${displayClass} matchingLocations`}>
					<div className={`${css.matchingLocationsText} matchingLocationsText`}>Nearby Locations</div>
					{Object.keys(matchingLocations).map((key, i) => {
						return (
							<div
								key={i}
								className={`${css.matchingLocationBtn} matchingLocationBtn`}
								data-location={matchingLocations[key].landmarkId}
								onClick={() => {
									this.props.setNearbyLocationData(key);
									this.setState({
										useNearbyLocation: key
									});
								}}>
								{matchingLocations[key].name}
							</div>
						)
					})}
				</div>
			);
		}
	}

	setUseNearbyLocation(keyValue) {
		this.useNearbyLocation = keyValue;
	}

	matchingLocationsMobileUI = (matchingLocations) => {
		const listingUUID = this.state.listingUUID;
		const selectedItem = document.querySelector(`[data-name="${listingUUID}"]`);

		if (selectedItem) {
			const nearbyLocationsElem = selectedItem.querySelector('.nearbyLocations');
			const nearbyLocationsSetting = window?.newData?.mobileSettings?.show_nearby_locations || null;
			const matchingLocationsClass = nearbyLocationsSetting ? 'matchingLocations matchingLocationsShow' : 'matchingLocations';
			const matchingLocationsText = document.createElement('div');
			matchingLocationsText.className = 'matchingLocationsText';
			matchingLocationsText.innerHTML = 'Nearby Locations';
			
			if (Object.keys(matchingLocations).length > 0) {
				const container = document.createElement('div');
				container.className = matchingLocationsClass;
				container.appendChild(matchingLocationsText);
				
				Object.keys(matchingLocations).forEach((key, i) => {
					const locationDiv = document.createElement('div');
					locationDiv.className = 'matchingLocationBtn';
					locationDiv.setAttribute('data-listing', key);
					locationDiv.innerHTML = `${matchingLocations[key].name}`;
					locationDiv.dataset.location = matchingLocations[key].landmarkId;
					locationDiv.onclick = (e) => {
						const targetListingUUID = e.target.dataset.listing;
						const selectedListing = document.querySelector(`[data-name="${targetListingUUID}"]`);
						if (selectedListing) {
							this.props.clearListItemSelection();
							this.setUseNearbyLocation(key);
							selectedListing.click();
						} else {
							this.props.buildList(`${matchingLocations[key].name}`);
							this.props.clearListItemSelection();
							const selectedNearbyLocation = document.querySelector(`[data-name="${key}"]`);
							this.setUseNearbyLocation(key);
							selectedNearbyLocation.click();
							const listingsCont = document.getElementById('listings');
							listingsCont.setAttribute('data-nearby-location', 'true');
						}
					};
					container.appendChild(locationDiv);
				});
				
				if (nearbyLocationsElem) {
					nearbyLocationsElem.innerHTML = '';
					nearbyLocationsElem.appendChild(container);
				}
			} 
		}
	}

	getAdjacentPoints = (point) => {
		const {
			flatData
		} = this.props;

		const {
			currentMap,
			endLocationMap
		} = this.state;

		let useMap = currentMap;
		const wfLineGrpName = flatData?.[useMap]?.lines;
		const wfLineGrpObj = flatData?.[wfLineGrpName];
		let pointArr = [];

		if (!wfLineGrpObj) {
			return pointArr;
		}

		Object.keys(wfLineGrpObj).forEach((line, i) => {
			const lineObj = flatData[line];
		
			if (lineObj.hasOwnProperty(point)) {
				if (lineObj.hasOwnProperty('display_name')) {
					delete lineObj.display_name;
				}

				Object.keys(lineObj).forEach((linePoint, i) => {
					if (linePoint !== point) {
						pointArr.push(linePoint);
					}
				});
			}
		});

		return pointArr
	}

	getMapRotationDegrees = (mapRotation) => {
		const baseRotation = parseInt(mapRotation) || 0;
		let greaterThan = 90;
		let lessThan = 270;

		if (baseRotation === 270) {
			greaterThan = 180;
			lessThan = 360;
		} else if (baseRotation === 180) {
			greaterThan = 270;
			lessThan = 90;
		} else if (baseRotation === 90) {
			greaterThan = 0;
			lessThan = 180;
		}

		return {
			baseRotation,
			greaterThan,
			lessThan,
		}
	}

	getLabelRotations = (wfPoint, pointRotation, labelPointsArr, rotationInnerValues) => {
		let rotationOuter = 0;
		let rotationInner = 0;

		if (pointRotation || pointRotation === 0) {
			rotationOuter = pointRotation;
		} else if (labelPointsArr.length === 1) {
			// Calculate the angle between the two points
			const point1 = this.pendingUpdates[wfPoint];
			const point2 = this.pendingUpdates[labelPointsArr[0]];
			const angle = Math.atan2(point2.y - point1.y, point2.x - point1.x);
			rotationOuter = (angle * 180) / Math.PI;
		
			// Normalize rotationOuter to 0-360
			rotationOuter = (rotationOuter + 360) % 360;
		
			if (rotationOuter === 180) {
				rotationOuter = 0;
			} else {
				rotationOuter += 180;
			}
		}
			
		// Normalize rotationOuter to 0-360
		rotationOuter = (rotationOuter + 360) % 360;
			
		if (rotationInnerValues.baseRotation === 180 && (rotationOuter > rotationInnerValues.greaterThan || rotationOuter < rotationInnerValues.lessThan)) {
			rotationInner = 180;
		} else if (rotationOuter > rotationInnerValues.greaterThan && rotationOuter < rotationInnerValues.lessThan) {
			rotationInner = 180;
		}

		return {
			rotationOuter,
			rotationInner
		}
	}

	getLabelStyles = (point, labelRotations, pointLabelColor, maxWidth, fontSize) => {
		const top = `${point.y}px`;
		const left = `${point.x}px`;
		const transform = `translate(0px, -50%) rotate(${labelRotations.rotationOuter}deg)`;
		const outer = {
			position: 'absolute',
			top,
			left,
			fontSize,
			background: pointLabelColor,
			transform
		}
		const inner = {
			maxWidth,
			transform: `rotate(${labelRotations.rotationInner}deg)`
		}

		return {
			outer,
			inner
		}
	}

	mapLabels = (imageIsLoaded, mapStyles, mapRotation) => {
		const {
			currentMap,
			mapsWithPointLocations,
		} = this.state;

		const showLabels = this.props.isMobile ? this.props.showLabels : this.state.showLabels;

		const currentLocations = mapsWithPointLocations?.[currentMap];
		if (!showLabels || !currentMap || !currentLocations) {
			return <></>;
		}

		let labelsArr = [];
		const mapZoom = this.pendingUpdates?.[currentMap]?.label_zoom_level || 2;
		const rotationInnerValues = this.getMapRotationDegrees(mapRotation);

		Object.keys(currentLocations).forEach((wfPoint, i) => {
			if (!currentLocations[wfPoint].name) {
				return;
			}

			const pointZoom = this.pendingUpdates?.[wfPoint]?.label_zoom_level || mapZoom;
			if (this.state.zoom < pointZoom) {
				return;
			}

			const labelPointsArr = this.getAdjacentPoints(wfPoint);
			const focusedPointObjSettings = currentLocations?.[wfPoint];
			const mapLabelColor = this.pendingUpdates?.[currentMap]?.label_color || 'transparent';
			const pointLabelColor = focusedPointObjSettings?.label_color || mapLabelColor;
			const pointRotation = parseInt(focusedPointObjSettings?.label_rotation);
			const displayLabel = focusedPointObjSettings?.display_label || false;
			const maxWidth = focusedPointObjSettings?.label_wrap_width || this.pendingUpdates?.[currentMap]?.label_wrap_width || 'unset';
			const fontSize = focusedPointObjSettings?.label_font_size || this.pendingUpdates?.[currentMap]?.label_font_size || '8px';

			if (!displayLabel) {
				return <></>;
			}

			const labelRotations = this.getLabelRotations(wfPoint, pointRotation, labelPointsArr, rotationInnerValues);
			const styles = this.getLabelStyles(currentLocations[wfPoint], labelRotations, pointLabelColor, maxWidth, fontSize);

			labelsArr.push(
				<div className={`matchingLocationLabelOuter ${imageIsLoaded}`} style={styles.outer} key={`label-${wfPoint}`}>
					<div className="matchingLocationLabelInner" style={styles.inner}>{currentLocations[wfPoint].name}</div>
				</div>
			);
		});
	
		return (
			<div className={`matchingLocationLabelCont ${imageIsLoaded}`} style={mapStyles}>
				{labelsArr}
			</div>
		)
	}

	setZoom = (zoom, cb) => {
		this.setState({ zoom }, () => {
			this.updateTransform();
			this.wayfindingRef.setZoom(this.state.zoom);
			if (cb) cb(); // callback
		});
	};
	
	setTranslate = (x, y) => {
		this.setState({ translateX: x, translateY: y }, this.updateTransform);
	};

	updateTransform = () => {
		const { zoom, translateX, translateY } = this.state;
		const el = this.wayfindingContainer.current;
		if (el) {
			if (this.zoomOriginMode === 'corner') {
				el.style.transformOrigin = '0 0';
			} else {
				el.style.transformOrigin = 'center center';
			}
			el.style.transform = `translate(${translateX}px, ${translateY}px) scale(${zoom})`;
		}
	};

	handleZoomIn = () => {
		this.zoomOriginMode = 'center';
		const { zoom } = this.state;
		const newZoom = Math.min(zoom + 0.3, this.MAX_ZOOM);
		this.setZoom(newZoom);

		dlWayfindingZoomIn({
			zoom: newZoom,
		});
	};
	
	handleZoomOut = () => {
		this.zoomOriginMode = 'center';
		const { zoom } = this.state;
		const newZoom = Math.max(zoom - 0.3, this.MIN_ZOOM);
		this.setZoom(newZoom);

		dlWayfindingZoomOut({
			zoom: newZoom,
		});
	};

	handleRefresh = () => {
		this.setState(
			{
				zoom: 1,
				translateX: 0,
				translateY: 0,
			},
			() => {
				this.updateTransform();
				this.wayfindingRef.setZoom(1);

				dlWayfindingMapReset();
			}
		);
	};

	getDistance = (touches) => {
		const [touch1, touch2] = touches;
		const dx = touch2.clientX - touch1.clientX;
		const dy = touch2.clientY - touch1.clientY;
		return Math.sqrt(dx * dx + dy * dy);
	};

	handleMouseMove = (e) => {
		if (!this.isDragging) return;
		this.setState({
			translateX: e.clientX - this.startX,
			translateY: e.clientY - this.startY
		}, this.updateTransform);
	};
	
	handleMouseDown = (e) => {
		this.isDragging = true;
		this.startX = e.clientX - this.state.translateX;
		this.startY = e.clientY - this.state.translateY;
	
		if (this.wrapperRef?.current) {
			this.wrapperRef.current.style.cursor = 'grabbing';
		}
		document.body.classList.add('noselect');
	};
	
	handleMouseUp = () => {
		if (this.isDragging) {
			this.isDragging = false;
	
			if (this.wrapperRef?.current) {
				this.wrapperRef.current.style.cursor = 'grab';
			}
			document.body.classList.remove('noselect');
		}
	};
	
	getMidpoint = (touches) => {
		const [touch1, touch2] = touches;
		return {
			x: (touch1.clientX + touch2.clientX) / 2,
			y: (touch1.clientY + touch2.clientY) / 2,
		};
	};
	
	handleTouchStart = (e) => {
		if (e.touches.length === 1) {
			dlWayfindingMapDrag();
			this.isDragging = true;
			this.startX = e.touches[0].clientX - this.state.translateX;
			this.startY = e.touches[0].clientY - this.state.translateY;
		} else if (e.touches.length === 2) {
			dlWayfindingMapPinch();
			this.isDragging = false;
			this.initialDistance = this.getDistance(e.touches);
		}
		document.body.classList.add('noselect');
	};
	
	handleTouchMove = (e) => {
		const touches = e.touches;
		if (touches.length === 1 && this.isDragging) {
			this.setState({
				translateX: touches[0].clientX - this.startX,
				translateY: touches[0].clientY - this.startY
			}, this.updateTransform);
		} else if (touches.length === 2) {
			const newDistance = this.getDistance(touches);
			const zoomFactor = newDistance / this.initialDistance;
			const newZoom = Math.max(this.MIN_ZOOM, Math.min(this.MAX_ZOOM, this.state.zoom * zoomFactor));
		
			const midpoint = this.getMidpoint(touches);
			const container = this.wayfindingContainer.current;
		
			if (container) {
				const rect = container.getBoundingClientRect();
		
				// Get midpoint relative to container top-left
				const offsetX = midpoint.x - rect.left;
				const offsetY = midpoint.y - rect.top;
		
				// Compute new translate values to lock the zoom under the fingers
				const scaleDiff = newZoom / this.state.zoom;
		
				const newTranslateX = this.state.translateX - (offsetX * (scaleDiff - 1));
				const newTranslateY = this.state.translateY - (offsetY * (scaleDiff - 1));
		
				this.zoomOriginMode = 'corner';
				
				this.setState({
					zoom: newZoom,
					translateX: newTranslateX,
					translateY: newTranslateY
				}, () => {
					this.updateTransform();
					this.wayfindingRef.setZoom(this.state.zoom);
				});
		
				this.initialDistance = newDistance;
			}
		}		
	};
	
	handleTouchEnd = () => {
		this.isDragging = false;
		document.body.classList.remove('noselect');
	};
	
	handleOrientationChange = () => {
		window.scrollTo(0, 0);
		const listings = document.getElementById('listings');
		if (listings) listings.scrollTo(0, 0);
	};

	handlePan = (dx, dy) => {
		this.setState(
			(prevState) => ({
				translateX: prevState.translateX + dx,
				translateY: prevState.translateY + dy
			}),
			this.updateTransform
		);
	};

	initMapConfig = () => {
		const { flatData } = this.props;
		const { activeMap } = this; 
	
		if (!flatData || !activeMap || !flatData[activeMap]) {
			console.warn('Missing data for activeMap:', activeMap);
			return;
		}
	
		let mapConfigUUID = Object.keys(flatData[activeMap]).find(key =>
			key.startsWith('wf_config.')
		);
	
		let mapContainerWidthUUID, mapContainerHeightUUID;
	
		for (const [key, val] of Object.entries(flatData)) {
			if (key.startsWith('setting.')) {
				if (val.name === 'map_container_width') {
					mapContainerWidthUUID = key;
					console.log('Map container width UUID:', mapContainerWidthUUID);
				} else if (val.name === 'map_container_height') {
					mapContainerHeightUUID = key;
					console.log('Map container height UUID:', mapContainerHeightUUID);
				}
			}
		}
	
		console.log('mapConfigUUID:', mapConfigUUID);
		console.log('flatData[mapConfigUUID]:', flatData[mapConfigUUID]);
	
		if (mapConfigUUID && mapContainerWidthUUID && mapContainerHeightUUID) {
			const width = parseFloat(flatData[mapConfigUUID][mapContainerWidthUUID]?.string) || 1;
			const height = parseFloat(flatData[mapConfigUUID][mapContainerHeightUUID]?.string) || 1;
	
			this.setState({
				mapContainerWidth: width,
				mapContainerHeight: height,
			});
		}
	};
	
	initResizeObserver = () => {
		if (!this.props.isMobile) return;
		
		const modalEl = this.modalRef.current;
		const containerEl = this.mapContainerRef.current;

		if (!modalEl || !containerEl) return;

		this.wayfindingModalResizeObserver = new ResizeObserver((entries) => {
			const { mapContainerWidth, mapContainerHeight } = this.state;
			for (const entry of entries) {
				const { width, height } = entry.contentRect;
				const scaleRatioX = width / mapContainerWidth;
				const scaleRatioY = height / mapContainerHeight;
				const useScale = Math.min(scaleRatioX, scaleRatioY) || 1;

				containerEl.style.transform = `translate(-50%, -50%) scale(${useScale})`;
				containerEl.style.transformOrigin = 'center center';
			}
		});

		this.wayfindingModalResizeObserver.observe(modalEl);
	};

	toggleRestrictions = () => {
		if (!this.state.listingUUID) {
			return;
		}

		this.mapHasLoadedOnce = false; // prevents map from reloading
		this.setAnimationFrameId = null;

		this.setState(prev => ({
			adaEnabled: !prev.adaEnabled,
			currentSystem: this.activeSystem,
			imageLoaded: false,
			locationMarker: <></>,
			showInstructions: false,
			showInstructionsIndex: 0,
		}), () => {
			setTimeout(() => {
				this.stopAnimation();
				this.clearCanvas();

				this.setState({
					currentMap: this.activeMap,
					message: null,
				}, () => {
					this.getLocation();
					setTimeout(() => {
						this.reloadImage();
					}, 50);
				});
			});
		});
	}

	qrCode = () => {
		const {
			css,
			qrCodeText,
		} = this.props;

		const qrCodeURL = this.buildQRCodeURL();

		return (
			<div className={`${css.qrContainer} qrContainer ${css.wayfindingQrContainer} wayfindingQrContainer`} >
				<div className={`${css.qrTextContainer} qrTextContainer`}>
					<FontAwesomeIcon icon={faMobileAlt}/>
					<p>{qrCodeText}</p>
				</div>
				<QRCode
					bgColor={"#fff"} // Color of the bright squares
					fgColor={"#000"} // Color of the dark squares
					level="L" // QR Error correction level: L, M, Q, H
					style={{ width: '100%', height: '100%', border: `10px solid #fff` }} // Size in pixels
					value={qrCodeURL} // The url
				/>
			</div>
		)
	}

	renderAdaToggleButton() {
		const { isMobile, css } = this.props;
		const { adaEnabled, showZoomBtns } = this.state;

		if (!this.hasPointRestrictions) return null;

		return (
			<div className={`${isMobile ? '' : css.adaBtnContainer} adaBtnContainer ${!showZoomBtns ? `${css.noZoomBtns} noZoomBtns` : ''}`}>
			<div
				id="adaBtn"
				className={`${isMobile ? '' : css.adaBtn} adaBtn ${adaEnabled ? `${css.adaActive} adaActive` : ''}`}
				onClick={this.toggleRestrictions}
			>
				<Icons alt="Icon Wheelchair" fill={null} value="wheelchair" />
				<span>+</span>
				<Icons alt="Icon Stroller" fill={null} value="stroller" />
				<div className={`${isMobile ? 'adaTextMobile' : css.adaText} adaText ${adaEnabled ? `${css.adaTextActive} adaTextActive` : ''}`}>
				Accessible Routing
				</div>
			</div>
			</div>
		);
	}

	render() {
		const {
			activeMap,
			activeSystem,
			campusMap,
		} = this;

		const {
			currentMap,
			currentSystem,
			endLocationMap,
			graphicSettingsArr,
			hideMap,
			locationMarker,
			mapKey,
			mapImage,
			matchingLocations,
			imageLoaded,
			message,
		} = this.state;

		const {
			css,
			env,
			isMobile,
			locationMarkerUse,
		} = this.props;

		const wfEnv = qaActive() === 1 ? 'ciprod' : env;
		let imgSource = mapImage;
		const imageIsLoaded = imageLoaded ? `${css.mapLoaded} mapLoaded` : `${css.mapLoading} mapLoading`;
		const hideMapElements = hideMap ? 'hideMap' : '';
		let configuration = this.pendingUpdates?.[activeSystem]?.configuration;
		let mapRotation = parseInt(this.pendingUpdates?.[configuration]?.map_rotation) || '0';

		if (locationMarkerUse && endLocationMap) {
			const lastMap = this.getMapData('wf_map_graphic');
			imgSource = this.pendingUpdates?.[lastMap]?.source; // PLACEHOLDER: use endLocationMap instead of lastMap to show marker inside building

			if (lastMap === campusMap) {
				configuration = this.pendingUpdates[campusMap].configuration;
			}
		}

		// campus map override
		if (currentMap === campusMap && (!currentSystem || currentSystem === 'No System')) {
			configuration = this.pendingUpdates[campusMap].configuration;
			mapRotation = parseInt(this.pendingUpdates?.[configuration]?.map_rotation) || '0';
		}

		let contWidth = `${this.pendingUpdates?.[configuration]?.map_container_width}px` || '500px';
		let contHeight = `${this.pendingUpdates?.[configuration]?.map_container_height}px` || '500px';

		// builder canvas styles
		let backgroundStyle = {
			backgroundColor: this.pendingUpdates?.[configuration]?.background_color || 'white',
			height: contHeight,
			width: contWidth,
		};

		// canvas styles
		let canvasWidth = this.pendingUpdates?.[activeMap]?.canvas_width;
		let canvasHeight = this.pendingUpdates?.[activeMap]?.canvas_height;
		const canvasTop = this.pendingUpdates?.[configuration]?.canvas_position_top;
		const canvasLeft = this.pendingUpdates?.[configuration]?.canvas_position_left;

		let canvasStyle = {
			top: canvasTop,
			left: canvasLeft,
			zIndex: 10,
		};

		if (mapRotation === 90 || mapRotation === 270) {
			canvasWidth = this.pendingUpdates?.[activeMap]?.canvas_height;
			canvasHeight = this.pendingUpdates?.[activeMap]?.canvas_width;
		}

		// map graphic styles
		let mapStyles = {
			top: this.pendingUpdates?.[configuration]?.background_top,
			left: this.pendingUpdates?.[configuration]?.background_left,
			width: this.pendingUpdates?.[configuration]?.background_size,
			transformOrigin: `top left`,
		};

		if (mapRotation === 90) {
			mapStyles = {
				...mapStyles,
				transform: `rotate(90deg) translate(0, -${this.mapImg?.current?.height}px)`,
			};
		} else if (mapRotation === 180) {
			mapStyles = {
				...mapStyles,
				transform: `rotate(180deg) translate(-${this.mapImg?.current?.width}px, -${this.mapImg?.current?.height}px)`,
			};
		} else if (mapRotation === 270) {
			mapStyles = {
				...mapStyles,
				transform: `rotate(270deg) translate(-${this.mapImg?.current?.width}px, 0)`,
			};
		}

		if (!configuration || !canvasHeight || !canvasWidth) {
			return (
				<div id='canvasScrollCont' className={`${css.wayfindingErrorCont} wayfindingErrorCont`}>
					<div className={`${css.wayfindingErrorText} wayfindingErrorText`} >
						Error loading wayfinding data
					</div>
				</div>
			);
		}

		const showZoomWrapper = (children) => {
			if (isMobile || this.state.showZoomBtns) {
				return (
					<div id="wayfindingWrapper" className={`${css.wayfindingWrapper} wayfindingWrapper`} ref={this.modalRef}>
						<div id="wayfindingMapContainerWrapper" className={`${css.wayfindingContainer} wayfindingContainer`} ref={this.wayfindingContainer}>
							<div id="wayfindingMapContainer" className={`${css.wayfindingMapContainer} wayfindingMapContainer`} ref={this.mapContainerRef}>
								{children}
							</div>
						</div>
						<div className={`${css.refreshBtnContainer} refreshBtnContainer`}>
							<div id="refreshBtn" className={`${css.refreshBtn} refreshBtn`} onClick={this.handleRefresh}>
								<FontAwesomeIcon icon={faRefresh}/>
							</div>
						</div>
						<div className={`${css.zoomBtnContainer} zoomBtnContainer`}>
							<div id="zoomIn" className={`${css.zoomIn} zoomIn`} onClick={this.handleZoomIn}>
								<FontAwesomeIcon icon={faPlus}/>
							</div>
							<div id="zoomOut" className={`${css.zoomOut} zoomOut`} onClick={this.handleZoomOut}>
								<FontAwesomeIcon icon={faMinus}/>
							</div>
						</div>
						{this.state.showZoomBtns && !isMobile && (
							<div className={`${css.panBtnContainer} panBtnContainer`}>
								<svg
									viewBox="0 0 438.86 438.86"
									className={`${css.dpadSVG} dpadSVG`}
								>
									<path
										d="M277.28,158.69h129.02c.43,0,7.28,1.89,8.24,2.27,6.63,2.65,10.75,8.4,13.1,14.93,5.7,27.02,4.82,57.52.32,83.89-1.25,7.32-5.73,14.73-12.62,17.75-1.21.53-8.31,2.63-9.04,2.63h-129.02v129.06c0,.73-2.1,7.84-2.63,9.05-3.02,6.89-10.35,11.9-17.74,12.62-26.3,2.58-55.02,3.15-83.86-.32-6.52-2.35-12.27-6.47-14.92-13.11-.38-.96-2.27-7.81-2.27-8.24v-129.06H26.83c-.73,0-7.84-2.1-9.04-2.63-6.89-3.02-11.89-10.36-12.61-17.75-2.58-26.31-2.24-56.38.32-83.89,2.35-6.52,6.47-12.28,13.1-14.93.96-.38,7.81-2.27,8.24-2.27h129.02V29.63c0-.73,2.1-7.84,2.63-9.05,3.02-6.89,10.35-11.57,17.74-12.3,26.3-2.58,54.29-3.44,83.86,0,6.52,2.35,12.27,6.47,14.92,13.11.38.96,2.27,7.81,2.27,8.24v129.06ZM248.09,94.45l-32.09-56.06-30.96,56.06h63.05ZM91.63,187.89l-57.21,30.38,57.21,32.69v-63.07ZM341.49,187.89v63.07l57.21-32.69-57.21-30.38ZM248.09,344.4h-63.05l30.96,56.06,32.09-56.06Z"
									/>
								</svg>
								<div onClick={() => this.handlePan(0, -50)} className={`${css.panButton} ${css.panUp} panButton panUp`}></div>
								<div onClick={() => this.handlePan(-50, 0)} className={`${css.panButton} ${css.panLeft} panButton panLeft`}></div>
								<div onClick={() => this.handlePan(50, 0)} className={`${css.panButton} ${css.panRight} panButton panRight`}></div>
								<div onClick={() => this.handlePan(0, 50)} className={`${css.panButton} ${css.panDown} panButton panDown`}></div>
							</div>
						)}

						{this.renderAdaToggleButton()}
						
						{this.showQRCode() &&
							this.qrCode()
						}

					</div>
				);
			}
			return children;
		};

		return showZoomWrapper(
			<div id='canvasScrollCont' className={`${css.canvasScrollCont} ${hideMapElements} canvasScrollCont ${css.wayfindingCanvasScrollCont} wayfindingCanvasScrollCont`} ref={this.canvasScrollCont}>
				<div 
					className={`${css.viewerCanvas} viewerCanvas ${css.wayfindingViewerCanvas} wayfindingViewerCanvas`} 
					style={backgroundStyle}
					ref={this.graphicsRef}
				>
					{mapImage &&
						<img
							ref={this.mapImg}
							key={mapKey}
							className={`${css.mapGraphic} mapGraphic ${imageIsLoaded}`}
							onLoad={() => {
								this.preloadNextMap();
								this.handleImageLoad(() => {
									this.renderPathOnMap(canvasTop, canvasLeft);
								});
							}}
							src={`https://ts-wayfinding.s3.amazonaws.com/${wfEnv}/${imgSource}`}
							style={mapStyles}
							alt='map'
						/>
					}
					<canvas 
						ref={this.canvas} 
						tabIndex="0"
						id="canvas" 
						className={`${css.canvasArea} canvasArea ${imageIsLoaded}`} 
						width={canvasWidth}
						height={canvasHeight}
						style={canvasStyle}
					>
					</canvas>
					{this.loadingMessage(imageIsLoaded)}
					{this.mapLabels(imageIsLoaded, mapStyles, mapRotation)}
					{this.renderGraphics(graphicSettingsArr, configuration)}
					{locationMarker}
					<div className={`${css.instructionCont} instructionCont`}>
						{this.transitionInstructions()}
					</div>
					{message}
				</div>

				{this.matchingLocationsUI(matchingLocations)}


				{this.state.preloadImage &&
					<img 
						src={`https://ts-wayfinding.s3.amazonaws.com/${wfEnv}/${this.state.preloadImage}`}
						alt='preload map image'
						style={{
							display: 'none',
							position: 'absolute',
							bottom: 0,
							left: 0,
							height: '6em',
						}}
					/>
				}

				{!this.state.showZoomBtns && !isMobile && this.renderAdaToggleButton()}

				{this.showQRCode() && !this.state.showZoomBtns && (
					this.qrCode()
				)}
			</div>
		);
	}
}

export {
	WayfindingComponent,
};